var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElections(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 756.985,
    height: 493.703,
    viewBox: "0 0 756.985 493.703",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Voting-pana",
    transform: "translate(-49.67 -41.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-56",
    transform: "translate(59.106 41.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5652",
    "data-name": "Path 5652",
    d: "M611.91,123.974l-1.217-4.5c-10.247-37.917-40.015-67.569-78-76a101.483,101.483,0,0,0-14.838-2.156c-36.016-2.55-72.948,14.571-94.671,43.887-12.751,17.237-21.213,38.891-39.3,50.285-23.543,14.814-53.89,6.723-80.169-1.762s-56.673-16.518-80.134-1.588c-14.71,9.343-23.381,26.174-27.345,43.226-10.433,45.208,9.007,93.894,42.716,125.088s79.613,46.367,125.273,50.123c63.975,5.286,131.127-11.592,180.613-53.253S623.432,187.753,611.91,123.974Z",
    transform: "translate(-36.224 -41.074)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_336",
    "data-name": "Ellipse 336",
    cx: 48.686,
    cy: 48.686,
    r: 48.686,
    transform: "matrix(0.92, -0.393, 0.393, 0.92, 619.765, 97.017)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_337",
    "data-name": "Ellipse 337",
    cx: 48.686,
    cy: 48.686,
    r: 48.686,
    transform: "translate(0 105.32) rotate(-80.78)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-56",
    transform: "translate(49.67 531.961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5653",
    "data-name": "Path 5653",
    d: "M803.905,464.851c0,.162-168.858.3-377.094.3s-377.141-.081-377.141-.3,168.824-.3,377.141-.3S803.905,464.689,803.905,464.851Z",
    transform: "translate(-49.67 -464.55)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-56",
    transform: "translate(516.665 115.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5654",
    "data-name": "Path 5654",
    d: "M493,434.264l.336,35.517,46.75-.325c-.29-4.219-24.505-12.519-24.505-12.519l.765-22.778Z",
    transform: "translate(-446.094 -52.465)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10673",
    "data-name": "Group 10673",
    transform: "translate(53.68 402.607)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5655",
    "data-name": "Path 5655",
    d: "M500.184,452.246a1.8,1.8,0,0,0-1.31,2.063,1.82,1.82,0,0,0,2.144,1.24,1.889,1.889,0,0,0,1.38-2.191,1.924,1.924,0,0,0-2.388-1.055",
    transform: "translate(-498.844 -452.2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10674",
    "data-name": "Group 10674",
    transform: "translate(47.184 413.735)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5656",
    "data-name": "Path 5656",
    d: "M493.24,465.382l.116-3.582,44.779,1.032s2.087.846,1.855,2.226Z",
    transform: "translate(-493.24 -461.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5657",
    "data-name": "Path 5657",
    d: "M513.67,453.637c0,.209-1.159.313-2.318,1.02s-1.716,1.611-1.924,1.53.128-1.333,1.5-2.168S513.717,453.44,513.67,453.637Z",
    transform: "translate(-443.488 -49.396)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5658",
    "data-name": "Path 5658",
    d: "M517.746,455.24c0,.209-.939.58-1.716,1.507s-.985,1.878-1.217,1.878-.371-1.229.6-2.318S517.734,455.032,517.746,455.24Z",
    transform: "translate(-442.649 -49.121)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5659",
    "data-name": "Path 5659",
    d: "M519.78,460.513c-.209,0-.533-1.032,0-2.214s1.646-1.658,1.75-1.484-.568.811-1.02,1.8S520,460.513,519.78,460.513Z",
    transform: "translate(-441.877 -48.864)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5660",
    "data-name": "Path 5660",
    d: "M513.378,449.223c-.1.2-1.159-.093-2.434,0s-2.318.487-2.423.3.846-.962,2.318-1.043S513.482,449.084,513.378,449.223Z",
    transform: "translate(-443.625 -50.186)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5661",
    "data-name": "Path 5661",
    d: "M512.705,445.086a4.532,4.532,0,0,1-2.318,0,10.433,10.433,0,0,1-2.457-.7,9.583,9.583,0,0,1-1.345-.661,2.63,2.63,0,0,1-.707-.51.9.9,0,0,1-.116-1.159,1.287,1.287,0,0,1,1-.51,3.247,3.247,0,0,1,.881.116,8.968,8.968,0,0,1,1.461.464,8.265,8.265,0,0,1,2.168,1.321c1.09.939,1.461,1.75,1.379,1.785s-.638-.6-1.739-1.379a9.527,9.527,0,0,0-2.1-1.09,7.883,7.883,0,0,0-1.345-.383c-.487-.127-.916-.127-1.043.081s0,.116,0,.255a2.016,2.016,0,0,0,.522.371,11.778,11.778,0,0,0,1.24.661,13.192,13.192,0,0,0,2.26.811,16.23,16.23,0,0,1,2.26.522Z",
    transform: "translate(-444.088 -51.288)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5662",
    "data-name": "Path 5662",
    d: "M511.557,445.841a3.477,3.477,0,0,1-.626-2.133,6.954,6.954,0,0,1,.313-2.423,6.881,6.881,0,0,1,.591-1.356,1.9,1.9,0,0,1,1.484-1.159,1.09,1.09,0,0,1,.985.614,3.04,3.04,0,0,1,.243.811,4.557,4.557,0,0,1,0,1.484,5.1,5.1,0,0,1-1,2.318c-.9,1.159-1.855,1.414-1.878,1.345a9.641,9.641,0,0,0,1.414-1.634,5.1,5.1,0,0,0,.73-2.087,4.309,4.309,0,0,0,0-1.275c-.081-.475-.267-.846-.452-.8a1.6,1.6,0,0,0-.811.73,6.734,6.734,0,0,0-.58,1.159,7.327,7.327,0,0,0-.44,2.2C511.441,444.995,511.685,445.806,511.557,445.841Z",
    transform: "translate(-443.241 -51.731)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5663",
    "data-name": "Path 5663",
    d: "M470.072,432.08,464.96,465.7l44.234,6.839c.371-4.034-21.248-15.591-21.248-15.591l4.208-21.4Z",
    transform: "translate(-450.558 -52.796)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10675",
    "data-name": "Group 10675",
    transform: "translate(22.435 400.228)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5664",
    "data-name": "Path 5664",
    d: "M473.443,450.15a1.727,1.727,0,0,0-1.553,1.75,1.75,1.75,0,0,0,1.843,1.5,1.82,1.82,0,0,0,1.646-1.866,1.855,1.855,0,0,0-2.1-1.356",
    transform: "translate(-471.89 -450.148)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10676",
    "data-name": "Group 10676",
    transform: "translate(14.449 409.527)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5665",
    "data-name": "Path 5665",
    d: "M465,461.543l.661-3.373,42.16,7.825s1.843,1.159,1.414,2.388Z",
    transform: "translate(-465 -458.17)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5666",
    "data-name": "Path 5666",
    d: "M486.045,453.483c0,.209-1.159.139-2.318.626s-1.866,1.263-2.052,1.159.325-1.24,1.75-1.808S486.115,453.309,486.045,453.483Z",
    transform: "translate(-447.903 -49.438)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5667",
    "data-name": "Path 5667",
    d: "M489.655,455.648c0,.2-.974.406-1.843,1.159s-1.217,1.623-1.437,1.588-.162-1.229.939-2.133S489.689,455.451,489.655,455.648Z",
    transform: "translate(-447.165 -49.065)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5668",
    "data-name": "Path 5668",
    d: "M490.772,460.95c-.2,0-.336-1.043.394-2.075s1.808-1.321,1.878-1.159-.661.684-1.252,1.542S490.992,460.973,490.772,460.95Z",
    transform: "translate(-446.474 -48.722)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5669",
    "data-name": "Path 5669",
    d: "M486.407,449.292c-.116.174-1.066-.255-2.318-.371s-2.249.1-2.318-.081.939-.777,2.388-.638S486.535,449.13,486.407,449.292Z",
    transform: "translate(-447.882 -50.233)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5670",
    "data-name": "Path 5670",
    d: "M486.4,445.315a4.636,4.636,0,0,1-2.214-.359,10.241,10.241,0,0,1-2.2-1.032,10.874,10.874,0,0,1-1.159-.835,2.586,2.586,0,0,1-.591-.591.846.846,0,0,1,.07-1.1,1.159,1.159,0,0,1,1.02-.325,2.912,2.912,0,0,1,.811.243,7.778,7.778,0,0,1,3.153,2.237c.881,1.055,1.159,1.878,1.032,1.9s-.51-.661-1.437-1.565a8.739,8.739,0,0,0-1.808-1.356,8.428,8.428,0,0,0-1.159-.568c-.44-.185-.846-.255-1-.081s-.07.1,0,.243a2.241,2.241,0,0,0,.44.44,11.276,11.276,0,0,0,1.066.812,12.748,12.748,0,0,0,2.017,1.1A14.346,14.346,0,0,1,486.4,445.315Z",
    transform: "translate(-448.154 -51.367)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5671",
    "data-name": "Path 5671",
    d: "M485.3,445.812a3.246,3.246,0,0,1-.267-2.11,6.745,6.745,0,0,1,.661-2.249,7.865,7.865,0,0,1,.765-1.159,1.831,1.831,0,0,1,1.588-.835,1.043,1.043,0,0,1,.835.719,3.051,3.051,0,0,1,.1.811,4.555,4.555,0,0,1-.22,1.4,4.776,4.776,0,0,1-1.287,2.017,2.968,2.968,0,0,1-1.982.985c-.058-.116.754-.394,1.577-1.333a4.637,4.637,0,0,0,1.02-1.855,4.171,4.171,0,0,0,.151-1.217c0-.452-.128-.835-.313-.823a1.588,1.588,0,0,0-.881.568,7.3,7.3,0,0,0-.719,1.043,7.139,7.139,0,0,0-.765,2.029C485.308,445,485.424,445.8,485.3,445.812Z",
    transform: "translate(-447.374 -51.621)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5672",
    "data-name": "Path 5672",
    d: "M463.606,308.76s-2.666-22.987-2.689-29.49h60.718s-4.787,89.872-7.175,106.645l-18.315,93.824-35.425-3.478s3.385-48.86,5.97-72.379c1.936-17.631,6.063-27.9,6.063-27.9Z",
    transform: "translate(-451.233 -77.121)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5673",
    "data-name": "Path 5673",
    d: "M524.08,279.27c-.336,4.15-3.211,97.847-3.686,112.186s-.881,86.684-.881,86.684H492.1l3.478-135.926L484.1,279.27Z",
    transform: "translate(-447.511 -77.121)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5674",
    "data-name": "Path 5674",
    d: "M600.724,217.29,588.17,240.659,620,258.174l8.358-1.576,9.737-18.535Z",
    transform: "translate(-430.944 -86.987)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5675",
    "data-name": "Path 5675",
    d: "M600.775,217.293a4.777,4.777,0,0,1,.7.348l2.04,1.09,7.709,4.2,27.055,14.9.243.128-.128.243c-2.991,5.726-6.283,12-9.714,18.547l-.07.128h-.139l-3.767.707-4.637.858h-.1l-.093-.058-31.808-17.562-.209-.1.116-.209,9.273-17.052,2.562-4.637.672-1.159a3.14,3.14,0,0,1,.232-.383s-.069.162-.209.452l-.649,1.252-2.481,4.741-9,17.04-.1-.325,31.866,17.457h-.2l4.579-.858,3.767-.707-.209.151,9.749-18.547.116.371-26.766-15.069-7.7-4.37-2.052-1.159-.533-.313Z",
    transform: "translate(-430.995 -86.99)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5676",
    "data-name": "Path 5676",
    d: "M608.335,232.907l-4.2,3.42-1.008-.533.417-5.413,1.1.58-.313,3.86,3.025-2.446Z",
    transform: "translate(-428.563 -84.903)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5677",
    "data-name": "Path 5677",
    d: "M606.242,234.992a2.11,2.11,0,1,1,.951,2.724,1.959,1.959,0,0,1-.951-2.724Zm2.736,1.426a.985.985,0,1,0-1.356.487.962.962,0,0,0,1.356-.487Z",
    transform: "translate(-428.105 -84.369)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5678",
    "data-name": "Path 5678",
    d: "M611.431,239.817a1.6,1.6,0,0,1-.916-.209,1.263,1.263,0,0,1-.626-1.889l.73-1.391-.522-.278.394-.753.522.278.44-.835.985.522-.44.823.846.452-.394.753-.846-.44-.73,1.379a.452.452,0,0,0,.185.672.846.846,0,0,0,.464.081Z",
    transform: "translate(-427.521 -84.209)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5679",
    "data-name": "Path 5679",
    d: "M615.49,240.186l-2.573-1.356a1.02,1.02,0,0,0,.614,1.159,1.275,1.275,0,0,0,1.02.116l.232.846A2.237,2.237,0,0,1,612.071,238a1.959,1.959,0,0,1,2.736-.788,1.889,1.889,0,0,1,.835,2.689Zm-2.318-1.936,1.669.881a.9.9,0,0,0-.464-1.159.916.916,0,0,0-1.206.278Z",
    transform: "translate(-427.164 -83.86)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5680",
    "data-name": "Path 5680",
    d: "M597.721,228.384l-2.852-1.762-3.292-.858-2.052,2.318,1.947,2.017s7.233,1.472,9.273,4.637-1.739,4.637-5.17,3.478-11.035-3.478-13.447-4.08-5.367-1.066-6.816-3.107-4.938-2.817-4.938-2.817l-.406-10.433s16.5-1.507,19.3-1.959,5.8-.487,6.5.927,2.318,3.883,2.318,3.883l2.318,2.736Z",
    transform: "translate(-433.842 -87.266)",
    fill: "#ac815f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5681",
    "data-name": "Path 5681",
    d: "M538.159,134.319a23.5,23.5,0,0,0-19.95-24.853l-1.159-.174c-13.1-1.159-21.422,9.273-22.245,22.372l-4.637,43.5-.209,2.11,29.026,10.514,1.611-11.024s12.751,0,14.791-12.508C536.374,158.233,537.382,145.69,538.159,134.319Z",
    transform: "translate(-446.578 -104.193)",
    fill: "#ac815f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5682",
    "data-name": "Path 5682",
    d: "M518.626,168.473A30.648,30.648,0,0,1,503,161.24s2.492,9.552,15.069,10.294Z",
    transform: "translate(-444.502 -95.909)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5683",
    "data-name": "Path 5683",
    d: "M527.633,141.031a1.785,1.785,0,0,1-1.982,1.53,1.727,1.727,0,0,1-1.6-1.878,1.808,1.808,0,0,1,1.994-1.542,1.716,1.716,0,0,1,1.588,1.889Z",
    transform: "translate(-441.152 -99.429)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5684",
    "data-name": "Path 5684",
    d: "M529.408,136.126c-.255.2-1.461-1.008-3.373-1.287s-3.478.464-3.64.2.2-.5.881-.858a4.985,4.985,0,0,1,2.956-.44,4.764,4.764,0,0,1,2.643,1.31C529.4,135.593,529.524,136.034,529.408,136.126Z",
    transform: "translate(-441.421 -100.297)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5685",
    "data-name": "Path 5685",
    d: "M512.993,139.1a1.8,1.8,0,0,1-1.994,1.53,1.7,1.7,0,0,1-1.588-1.878,1.808,1.808,0,0,1,1.982-1.542,1.739,1.739,0,0,1,1.6,1.889Z",
    transform: "translate(-443.483 -99.736)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5686",
    "data-name": "Path 5686",
    d: "M513.108,134c-.255.2-1.461-1.008-3.373-1.287s-3.478.464-3.64.2.2-.51.881-.858a4.891,4.891,0,0,1,2.956-.452,4.7,4.7,0,0,1,2.643,1.321C513.1,133.453,513.224,133.905,513.108,134Z",
    transform: "translate(-444.016 -100.638)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5687",
    "data-name": "Path 5687",
    d: "M516.3,149.031a12.937,12.937,0,0,1,3.188-.093c.5,0,.985,0,1.159-.325a2.6,2.6,0,0,0-.1-1.507c-.29-1.252-.58-2.562-.893-3.941-1.159-5.61-2.017-10.189-1.785-10.236s1.391,4.463,2.608,10.073c.29,1.379.556,2.689.823,3.953a2.852,2.852,0,0,1,0,1.959,1.229,1.229,0,0,1-.916.591,3.477,3.477,0,0,1-.846,0,13.261,13.261,0,0,1-3.234-.475Z",
    transform: "translate(-442.385 -100.416)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5688",
    "data-name": "Path 5688",
    d: "M511.327,147.23c.313,0,0,2.11,1.565,3.86s3.8,1.843,3.779,2.145-.556.325-1.5.209A5.216,5.216,0,0,1,512,151.774a4.555,4.555,0,0,1-1.159-3.211C510.875,147.682,511.188,147.2,511.327,147.23Z",
    transform: "translate(-443.255 -98.14)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5689",
    "data-name": "Path 5689",
    d: "M514.76,127.526c-.267.487-2.144,0-4.44-.1s-4.2.267-4.428-.243c-.093-.243.29-.684,1.1-1.078a7.7,7.7,0,0,1,6.758.267C514.516,126.819,514.876,127.247,514.76,127.526Z",
    transform: "translate(-444.044 -101.607)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5690",
    "data-name": "Path 5690",
    d: "M529.44,131.258c-.406.383-1.658-.267-3.246-.522s-2.968-.151-3.211-.649c-.1-.243.174-.649.823-.974a4.764,4.764,0,0,1,5.2.951C529.5,130.6,529.613,131.073,529.44,131.258Z",
    transform: "translate(-441.325 -101.086)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5691",
    "data-name": "Path 5691",
    d: "M537.643,128.62s-2.121-8.3-5.611-10.688c-4.231-2.9-6.955,1.808-11.1,0s-8.2-4.637-13.145-1.947c-5.413,2.956-3.478,5.877-4.637,11.36-4.637,22.256-9.633,27.983-9.273,17.249,0-1.159-3.025-2.585-2.771-7.546.336-6.445,1.252-14.177,3.339-18.466,1.774-3.617,4.324-5.912,8.636-8.219,6.816-3.64,15.243-2.481,20.865-1.043S539.672,118.918,537.643,128.62Z",
    transform: "translate(-446.399 -104.394)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5692",
    "data-name": "Path 5692",
    d: "M495.48,139.845a3.478,3.478,0,0,0-3.165-3.814c-2.318-.128-5.147.8-5.715,5.634-1.008,8.566,7.8,7.813,7.848,7.569S495.1,143.427,495.48,139.845Z",
    transform: "translate(-447.125 -99.924)",
    fill: "#ac815f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5693",
    "data-name": "Path 5693",
    d: "M492.564,145.4a3.98,3.98,0,0,1-.429.174,1.542,1.542,0,0,1-1.159-.116,3.733,3.733,0,0,1-1.31-3.478,4.972,4.972,0,0,1,.661-2.087,1.739,1.739,0,0,1,1.264-1.008.765.765,0,0,1,.835.51c.081.255,0,.417.058.44s.2-.128.174-.487a1,1,0,0,0-.278-.58,1.09,1.09,0,0,0-.8-.313,2.075,2.075,0,0,0-1.716,1.159,5.17,5.17,0,0,0-.8,2.318c-.151,1.739.545,3.478,1.739,3.964a1.623,1.623,0,0,0,1.391-.07C492.471,145.6,492.587,145.415,492.564,145.4Z",
    transform: "translate(-446.724 -99.536)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5694",
    "data-name": "Path 5694",
    d: "M508.58,148.254c.139,0,.325-.869,1.159-1.5s1.727-.638,1.739-.777-.22-.162-.614-.162a2.562,2.562,0,0,0-1.426.545,2.446,2.446,0,0,0-.869,1.263C508.464,148.011,508.51,148.254,508.58,148.254Z",
    transform: "translate(-443.626 -98.364)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5695",
    "data-name": "Path 5695",
    d: "M508.223,145.9c.1.093.464-.151.951-.29s.9-.128.951-.267-.452-.394-1.09-.209S508.108,145.834,508.223,145.9Z",
    transform: "translate(-443.675 -98.483)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5696",
    "data-name": "Path 5696",
    d: "M496.921,162.7a.8.8,0,0,1-.2-.267.742.742,0,0,1,.093-.753c.185-.3.614-.522.962-1.043a1.078,1.078,0,0,0,.139-.985,7.246,7.246,0,0,0-.429-.811c-.533-.951,1.484-1.24,1.414-2.318a1.333,1.333,0,0,0-.325-.974c-.162-.185-.3-.22-.313-.2a1.831,1.831,0,0,1,.29,1.159c-.058.359-.325.626-.788.9a2.226,2.226,0,0,0-.684.614,1.055,1.055,0,0,0,0,1.09c.162.313.348.545.429.753a.7.7,0,0,1-.07.6c-.232.394-.661.684-.881,1.09a.951.951,0,0,0,0,1.055C496.747,162.746,496.921,162.723,496.921,162.7Z",
    transform: "translate(-445.552 -96.848)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5697",
    "data-name": "Path 5697",
    d: "M494.637,162.013s.058-.116.151-.29a3.048,3.048,0,0,1,.591-.638,3.2,3.2,0,0,0,.441-.5,1.159,1.159,0,0,0,.255-.811c0-.638-.487-1.09-.649-1.576s.093-.8.51-1.159a2.815,2.815,0,0,0,.556-.556,1.484,1.484,0,0,0,.243-.672c.058-.9-.487-1.252-.5-1.159a2.318,2.318,0,0,1,.151,1.159,1.46,1.46,0,0,1-.73.916,2.423,2.423,0,0,0-.638.614,1.264,1.264,0,0,0-.07,1.043c.243.614.638,1.032.672,1.437a1.511,1.511,0,0,1-.5,1.032,2.017,2.017,0,0,0-.51.811C494.556,161.874,494.6,162.013,494.637,162.013Z",
    transform: "translate(-445.842 -96.96)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5698",
    "data-name": "Path 5698",
    d: "M491.945,133.442c-3.315-2.84-4.637-9.471-3.651-13.725,1.623-7.106,8.114-12.461,15.2-14.142s14.641-.139,21.329,2.782c5.958,2.608,7.511,4.637,14.606,6.77,1.982.58,4.127-.487,6.167-.185s4.127,1.681,4.382,3.721a4.509,4.509,0,0,1-2.179,4.069,13.005,13.005,0,0,1-4.544,1.623c-18.118,3.918-32.782,8.393-51.306,9.088",
    transform: "translate(-446.894 -104.881)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5699",
    "data-name": "Path 5699",
    d: "M548.434,118.572a2.435,2.435,0,0,1-.568.185l-1.681.406c-1.449.336-3.57.811-6.178,1.368-5.228,1.159-12.461,2.6-20.483,4.1s-15.313,2.736-20.587,3.57c-2.643.417-4.776.742-6.26.951l-1.7.22a1.982,1.982,0,0,1-.6,0,2.829,2.829,0,0,1,.58-.151l1.692-.336,6.225-1.159,20.541-3.756,20.518-3.918,6.213-1.159,1.692-.3a2.157,2.157,0,0,1,.6-.023Z",
    transform: "translate(-446.513 -102.703)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5700",
    "data-name": "Path 5700",
    d: "M550.88,497.942c0-1.982-2.713-199.241-3.165-215.956-.359-12.971-7.674-14.9-8.821-15.069-3.559-.348-6.236.417-8.172,2.318-4.15,4.115-4.289,12.89-4,15.916l-7.106.719c-.058-.58-1.345-14.293,6.051-21.677,3.478-3.478,8.265-5.008,14.073-4.4h.139c5,.707,14.536,6.213,14.965,22.025.452,16.773,3.141,214.078,3.176,216.06Z",
    transform: "translate(-441.876 -80.243)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5701",
    "data-name": "Path 5701",
    d: "M535.434,255s9.563,2.689,10.688,3.2,6.955,9.621,6.955,9.621l2.029,6.631-1.356,5.506s-.788.788-1.576-.672a22.223,22.223,0,0,1-1.345-4.834l-2.087-3.373-1.774-1.345s-.359,4.521-1.658,4.857-4.892-.116-5.228-.9l-.336-.788s-2.921,2.318-4.277,1.808a2.029,2.029,0,0,1-1.4-1.576,3.327,3.327,0,0,1-2.875.893l-.429-.139a3.072,3.072,0,0,1-1.982-2.805h0Z",
    transform: "translate(-440.398 -80.984)",
    fill: "#ac815f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5702",
    "data-name": "Path 5702",
    d: "M537.581,265.44a7.546,7.546,0,0,1-1.519,3.478,8.809,8.809,0,0,1-2.713,2.6,27.406,27.406,0,0,1,2.318-2.91C536.746,266.936,537.372,265.371,537.581,265.44Z",
    transform: "translate(-439.671 -79.323)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5703",
    "data-name": "Path 5703",
    d: "M541.749,265.28a8.565,8.565,0,0,1-1.159,3.315,6.711,6.711,0,0,1-2.318,2.666c-.139-.116.939-1.275,1.866-2.921A18.246,18.246,0,0,1,541.749,265.28Z",
    transform: "translate(-438.889 -79.348)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5704",
    "data-name": "Path 5704",
    d: "M544.206,264.82a5.948,5.948,0,0,1,.452,3.06,6.143,6.143,0,0,1-.614,3.037,18.336,18.336,0,0,1,.081-3.049,19.034,19.034,0,0,1,.081-3.049Z",
    transform: "translate(-437.973 -79.421)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5705",
    "data-name": "Path 5705",
    d: "M515,178.24l28.725,43.365,39.238-1.994,1.159,20.761s-43.272,8.288-50.343,4.938C528.493,242.876,515,227.459,515,227.459Z",
    transform: "translate(-442.592 -93.203)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5706",
    "data-name": "Path 5706",
    d: "M565.131,214.17a17.559,17.559,0,0,1,.452,3.257c.209,2.2.475,4.892.765,7.848s.487,5.865.591,7.882a16.5,16.5,0,0,1,0,3.28,17.3,17.3,0,0,1-.452-3.246c-.209-2.214-.475-4.892-.765-7.859s-.487-5.854-.591-7.882A16.587,16.587,0,0,1,565.131,214.17Z",
    transform: "translate(-434.625 -87.484)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5707",
    "data-name": "Path 5707",
    d: "M575.451,225.519a39.169,39.169,0,0,1-9.691.672,20.088,20.088,0,0,1,4.822-.638A19.382,19.382,0,0,1,575.451,225.519Z",
    transform: "translate(-434.512 -85.699)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5708",
    "data-name": "Path 5708",
    d: "M574.908,218.135a15.07,15.07,0,0,1-4.822.614,26.938,26.938,0,0,1-4.845,0,15.4,15.4,0,0,1,4.822-.626A27.5,27.5,0,0,1,574.908,218.135Z",
    transform: "translate(-434.594 -86.87)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5709",
    "data-name": "Path 5709",
    d: "M525.291,177.422l-28.6-18.292s-26.221,8.891-32.457,28.446-14.664,95.123-10.665,102.24l6.7,10.5.846,9.946h68.693l.336-9.946,2.133-12.751Z",
    transform: "translate(-452.535 -96.245)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5710",
    "data-name": "Path 5710",
    d: "M529.124,280.971c0,.174-15.7.3-35.042.3s-35.042-.128-35.042-.3,15.7-.3,35.042-.3S529.124,280.809,529.124,280.971Z",
    transform: "translate(-451.5 -76.898)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5711",
    "data-name": "Path 5711",
    d: "M465.531,291.087a41.842,41.842,0,0,1,0-10.027A41.849,41.849,0,0,1,465.531,291.087Z",
    transform: "translate(-450.515 -76.836)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5712",
    "data-name": "Path 5712",
    d: "M472.341,291.087a41.845,41.845,0,0,1,0-10.027A41.845,41.845,0,0,1,472.341,291.087Z",
    transform: "translate(-449.431 -76.836)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5713",
    "data-name": "Path 5713",
    d: "M479.151,291.087a41.842,41.842,0,0,1,0-10.027,41.845,41.845,0,0,1,0,10.027Z",
    transform: "translate(-448.346 -76.836)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5714",
    "data-name": "Path 5714",
    d: "M485.973,291.087a40.311,40.311,0,0,1,0-10.027A41.842,41.842,0,0,1,485.973,291.087Z",
    transform: "translate(-447.262 -76.836)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5715",
    "data-name": "Path 5715",
    d: "M492.781,291.087a41.849,41.849,0,0,1,0-10.027A41.842,41.842,0,0,1,492.781,291.087Z",
    transform: "translate(-446.177 -76.836)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5716",
    "data-name": "Path 5716",
    d: "M499.591,291.087a41.849,41.849,0,0,1,0-10.027A41.842,41.842,0,0,1,499.591,291.087Z",
    transform: "translate(-445.093 -76.836)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5717",
    "data-name": "Path 5717",
    d: "M506.4,291.087a41.849,41.849,0,0,1,0-10.027A41.842,41.842,0,0,1,506.4,291.087Z",
    transform: "translate(-444.009 -76.836)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5718",
    "data-name": "Path 5718",
    d: "M513.211,291.087a41.845,41.845,0,0,1,0-10.027A41.842,41.842,0,0,1,513.211,291.087Z",
    transform: "translate(-442.925 -76.836)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5719",
    "data-name": "Path 5719",
    d: "M515.948,185a2.484,2.484,0,0,1,.1.661c0,.5.1,1.159.185,1.9.127,1.739.313,4.115.533,6.955.429,5.923.985,14.107,1.553,23.184s1.009,17.156,1.356,23.184c.151,2.9.267,5.286.348,7.025v1.9a2.717,2.717,0,0,1,0,.672,2.479,2.479,0,0,1-.1-.661c0-.5-.1-1.159-.174-1.9-.139-1.739-.313-4.115-.533-6.955-.406-5.993-.951-14.13-1.542-23.184s-1.02-17.144-1.379-23.184c-.139-2.91-.255-5.286-.348-7.025a18.3,18.3,0,0,0-.058-1.913A2.641,2.641,0,0,1,515.948,185Z",
    transform: "translate(-442.451 -92.127)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10677",
    "data-name": "Group 10677",
    transform: "translate(11.59 101.451)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5720",
    "data-name": "Path 5720",
    d: "M466.123,192.4c-3.037,11.592-3.165,21.48-3.478,33.466s-.475,26.29,6.955,35.656c6.793,8.5,17.388,10.792,27.878,13.632s21.016,6.4,31.878,6.955L516.605,267.1l-37.639-22.419Z",
    transform: "translate(-462.534 -192.4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5721",
    "data-name": "Path 5721",
    d: "M488.907,170.25s-19.567,4.892-22.233,19.115-1.89,61.321,3.478,69.76,68.195,29.4,68.195,29.4l9.088-24.494L502.3,237.564s.417-43.307-3.13-54.864S488.907,170.25,488.907,170.25Z",
    transform: "translate(-450.521 -94.475)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5722",
    "data-name": "Path 5722",
    d: "M500.363,181s.1.313.267.951a22.423,22.423,0,0,1,.614,2.828,98.064,98.064,0,0,1,1.159,10.989c.568,9.552.672,23.323.151,40.108l-.116-.209,45.208,26.406.209.128-.081.232c-2.921,7.894-5.97,16.09-9.076,24.494l-.1.278-.278-.093-5.448-1.855c-9.1-3.141-17.921-6.341-26.395-9.586s-16.576-6.538-24.111-10.143a61.739,61.739,0,0,1-10.572-6.1c-.394-.325-.753-.672-1.159-1.02a6.531,6.531,0,0,1-.881-1.24,14.473,14.473,0,0,1-1.159-2.724,48.6,48.6,0,0,1-1.263-5.529,174.713,174.713,0,0,1-1.971-20.529,294.041,294.041,0,0,1,.093-29.849c.22-3.478.51-6.248.754-8.114a25.046,25.046,0,0,1,.487-2.794,4.8,4.8,0,0,1-.081.719c-.081.475-.174,1.159-.278,2.087-.22,1.843-.464,4.567-.638,8.114-.348,7.036-.533,17.237.093,29.814a175.678,175.678,0,0,0,2.029,20.46,48.487,48.487,0,0,0,1.275,5.471,13.912,13.912,0,0,0,1.066,2.62,5.969,5.969,0,0,0,.811,1.159c.348.325.7.649,1.066.962a62.3,62.3,0,0,0,10.491,6.016c7.511,3.57,15.626,6.839,24.076,10.085s17.3,6.433,26.383,9.563l5.437,1.855-.371.185,9.1-24.494.116.359-45.1-26.545-.128-.07v-.139c.568-16.773.545-30.545.058-40.085a107.8,107.8,0,0,0-1-10.977,24.672,24.672,0,0,0-.545-2.828C500.421,181.325,500.363,181,500.363,181Z",
    transform: "translate(-450.548 -92.764)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5723",
    "data-name": "Path 5723",
    d: "M494.674,172.708a34.274,34.274,0,0,0-3.756-1.461,17.457,17.457,0,0,0-9.54,0,19.706,19.706,0,0,0-8.022,5.24c-1.692,1.82-2.423,3.211-2.527,3.153a3.661,3.661,0,0,1,.475-1,15.623,15.623,0,0,1,1.739-2.446,18.639,18.639,0,0,1,8.114-5.518,16.715,16.715,0,0,1,9.83.186,13.539,13.539,0,0,1,2.747,1.229,3.281,3.281,0,0,1,.939.614Z",
    transform: "translate(-449.623 -94.51)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5724",
    "data-name": "Path 5724",
    d: "M529.812,247.16c.151.07-2.179,5.8-5.2,12.9s-5.6,12.751-5.8,12.67,2.168-5.8,5.193-12.9S529.661,247.091,529.812,247.16Z",
    transform: "translate(-441.987 -82.232)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5725",
    "data-name": "Path 5725",
    d: "M531.064,269.1a26.524,26.524,0,0,1-5.332-1.716,25.361,25.361,0,0,1-5.112-2.318,26.19,26.19,0,0,1,5.321,1.727A26.464,26.464,0,0,1,531.064,269.1Z",
    transform: "translate(-441.697 -79.381)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5726",
    "data-name": "Path 5726",
    d: "M533.58,262.71a30.332,30.332,0,0,1-5.24-1.924,45.51,45.51,0,0,1-5.1-2.226,18.467,18.467,0,0,1,5.332,1.669A22.686,22.686,0,0,1,533.58,262.71Z",
    transform: "translate(-441.28 -80.417)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5727",
    "data-name": "Path 5727",
    d: "M534.965,257.461a21.5,21.5,0,0,1-4.556-1.959,20.646,20.646,0,0,1-4.289-2.492,20.541,20.541,0,0,1,4.556,1.959,19.71,19.71,0,0,1,4.289,2.492Z",
    transform: "translate(-440.822 -81.301)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5728",
    "data-name": "Path 5728",
    d: "M460.72,474.053h.626l1.843.151,7.048.638,25.931,2.481-.243.185c3.478-19.312,8.242-45.428,13.447-74.188,1.831-9.981,3.593-19.648,5.24-28.655h0c.927-23.578,1.739-44.049,2.318-58.574.3-7.245.556-13.029.719-17.04l.22-4.556c0-.5.058-.881.07-1.159a2.321,2.321,0,0,1,0-.406,2.176,2.176,0,0,1,0,.406v1.159c0,1.066-.07,2.6-.128,4.567-.128,4-.313,9.8-.556,17.04-.522,14.571-1.252,35-2.1,58.585h0c-1.646,9.007-3.408,18.674-5.228,28.667-5.263,28.69-10.062,54.806-13.6,74.107v.2h-.209l-25.908-2.631-7.036-.753-1.832-.209Z",
    transform: "translate(-451.233 -74.946)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-56",
    transform: "translate(351.706 107.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5729",
    "data-name": "Path 5729",
    d: "M392.381,431.557l-1.263,24.992s24.992,9.679,25.212,14.328l-48.57-.7.359-39.041Z",
    transform: "translate(-301.071 -45.465)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5730",
    "data-name": "Path 5730",
    d: "M375.2,451.065a2.005,2.005,0,0,0-1.4,2.249,1.924,1.924,0,0,0,2.214,1.414,2.087,2.087,0,0,0,1.472-2.388,1.982,1.982,0,0,0-2.457-1.217",
    transform: "translate(-300.115 -42.299)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5731",
    "data-name": "Path 5731",
    d: "M367.78,465.341V461.55l46.657,1.994s2.145.974,1.878,2.492Z",
    transform: "translate(-301.068 -40.624)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5732",
    "data-name": "Path 5732",
    d: "M389.223,452.889c0,.243-1.159.325-2.376,1.078s-1.808,1.727-2.029,1.634.162-1.461,1.6-2.318S389.281,452.668,389.223,452.889Z",
    transform: "translate(-298.365 -42.036)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5733",
    "data-name": "Path 5733",
    d: "M393.449,454.753c0,.232-.974.626-1.8,1.611s-1.066,2.052-1.31,2.04-.359-1.356.684-2.573S393.449,454.533,393.449,454.753Z",
    transform: "translate(-297.502 -41.722)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5734",
    "data-name": "Path 5734",
    d: "M395.436,460.558c-.209,0-.522-1.159.1-2.434s1.739-1.8,1.843-1.588-.6.881-1.1,1.947S395.68,460.558,395.436,460.558Z",
    transform: "translate(-296.707 -41.43)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5735",
    "data-name": "Path 5735",
    d: "M389.014,448.041c-.1.209-1.159-.128-2.527-.058s-2.4.475-2.515.278.893-1.043,2.469-1.1S389.13,447.856,389.014,448.041Z",
    transform: "translate(-298.492 -42.916)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5736",
    "data-name": "Path 5736",
    d: "M354.882,431.37l-.9,25.073s25.131,9.273,25.409,13.968h-48.57l-.2-39.041Z",
    transform: "translate(-306.983 -45.429)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5737",
    "data-name": "Path 5737",
    d: "M338,451.145a1.971,1.971,0,0,0-1.368,2.26,1.913,1.913,0,0,0,2.237,1.379,2.1,2.1,0,0,0,1.437-2.411,1.971,1.971,0,0,0-2.481-1.159",
    transform: "translate(-306.031 -42.287)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5738",
    "data-name": "Path 5738",
    d: "M330.79,465.521V461.73l46.611,1.321s2.156.939,1.913,2.469Z",
    transform: "translate(-306.956 -40.596)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5739",
    "data-name": "Path 5739",
    d: "M352.052,452.763c0,.243-1.159.348-2.318,1.159s-1.785,1.75-2.005,1.658.139-1.461,1.565-2.318S352.1,452.543,352.052,452.763Z",
    transform: "translate(-304.269 -42.05)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5740",
    "data-name": "Path 5740",
    d: "M356.282,454.573c.058.232-.974.638-1.774,1.634s-1.043,2.063-1.275,2.052-.383-1.345.638-2.573S356.282,454.341,356.282,454.573Z",
    transform: "translate(-303.41 -41.75)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5741",
    "data-name": "Path 5741",
    d: "M358.379,460.381c-.22,0-.545-1.159.058-2.434s1.727-1.82,1.82-1.611-.58.881-1.066,1.959S358.611,460.358,358.379,460.381Z",
    transform: "translate(-302.61 -41.461)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5742",
    "data-name": "Path 5742",
    d: "M351.772,447.918c-.093.22-1.159-.1-2.527,0s-2.388.522-2.5.313.881-1.043,2.457-1.159S351.888,447.732,351.772,447.918Z",
    transform: "translate(-304.418 -42.931)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5743",
    "data-name": "Path 5743",
    d: "M336.637,244.88c-.614.742-18.7,28.064-17.388,44.316s1.994,22.025,10.062,31.507c0,0,3.478,51.178,3.582,57.785,0,.73-1.971,13.18-3.141,44.478-.73,19.382-.452,58.284-.452,58.284l36.908.707s3.176-66.873,4.892-72a97.95,97.95,0,0,0,4-20.112c.58-7.28,7.964-58.307,7.964-57.322s10.154-46.53,10.885-58.11a149.813,149.813,0,0,0,0-20.2Z",
    transform: "translate(-308.804 -75.115)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5744",
    "data-name": "Path 5744",
    d: "M383.5,272c.719,1.032,29.837,102.565,29.837,109.485s-9.888,94.161-9.888,94.161l-36.074.707,6.271-89.593-3.57-20.749L348.7,311.748Z",
    transform: "translate(-304.105 -70.798)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5745",
    "data-name": "Path 5745",
    d: "M386.064,271.92a.938.938,0,0,1,0,.29l-.093.858c-.093.8-.22,1.9-.371,3.28-.348,2.852-.7,6.955-1.542,12.079-.417,2.539-1.043,5.286-1.669,8.242s-1.3,6.109-2.005,9.424c-1.379,6.642-2.863,13.91-4.312,21.654-2.91,15.394-5.066,29.42-6.422,39.6-.672,5.077-1.159,9.2-1.518,12.056-.174,1.391-.3,2.481-.406,3.28a4.959,4.959,0,0,1-.116.858,1.662,1.662,0,0,1-.058.29,1,1,0,0,1,0-.3,4.885,4.885,0,0,1,.058-.858l.29-3.292c.267-2.863.707-6.955,1.333-12.09,1.24-10.2,3.338-24.25,6.248-39.656,1.449-7.7,2.944-15.069,4.359-21.654.73-3.315,1.414-6.468,2.063-9.424s1.3-5.68,1.739-8.2c.893-5.054,1.31-9.192,1.716-12.032.209-1.379.371-2.481.5-3.269l.139-.846Z",
    transform: "translate(-301.106 -70.811)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5746",
    "data-name": "Path 5746",
    d: "M357.336,106.8c-3.188-3.941-11.592-3.848-13.748-1.507a6.433,6.433,0,0,0-8.543,2.318L326,109.059a9.273,9.273,0,0,0-4.393,1.484,3.2,3.2,0,0,0-.985,4.127c-3.2.638-4.637,5.263-2.492,7.651a3.4,3.4,0,0,0,.232,4.927,33.824,33.824,0,0,0-6.318,9.621,6.885,6.885,0,0,0-.719,4.637c.475,1.542,2.4,2.7,3.767,1.832a3.941,3.941,0,0,0-.429,4.266c-1.519,0-2.1,2.26-1.159,3.42s2.655,1.368,4.173,1.414a7.4,7.4,0,0,1,4.347,1,1.368,1.368,0,0,1-.556.939,6.225,6.225,0,0,0-1.866,8.381l.464.73c.8,1.287,2.91,2.55,4.208,3.327,3.327,1.982,5.379,1.75,9.158,2.527-1.159,2.4,4.706,8.2,12.1,3.246a137,137,0,0,0,38.67,7.488c2.086.128,4.637,0,5.657-1.832a5.182,5.182,0,0,0,4.857-1.3,15.371,15.371,0,0,0,3.06-4.254,9.123,9.123,0,0,0,7.013-7.836,11.3,11.3,0,0,0,4.706-7.767,6.607,6.607,0,0,0,4.289-8.694,39.726,39.726,0,0,0-3.651-12.577c2.434-.383,3.478-3.57,2.654-5.865s-2.956-3.872-4.95-5.3c1.762.568,3.478-1.588,3.13-3.478s-1.878-3.165-3.408-4.208a34.011,34.011,0,0,0-7.245-3.733c-.672-3.2-4.5-7.025-7.372-8.59-11.592-6.306-19.857-8.207-35.668,2.052",
    transform: "translate(-310.075 -98.264)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5747",
    "data-name": "Path 5747",
    d: "M384.518,129.42c-.475-8.253-5.9-18.408-14.13-17.573l-25.7,6.376a4.845,4.845,0,0,0-4.359,4.892l.626,55.015A15.069,15.069,0,0,0,353.2,192.781h0a15.069,15.069,0,0,0,17.921-14.107l.325-6.584s10.549-1.7,12.751-15.452C385.353,149.81,385.063,138.589,384.518,129.42Z",
    transform: "translate(-305.437 -96.3)",
    fill: "#ab645b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5748",
    "data-name": "Path 5748",
    d: "M375.742,136.647a1.75,1.75,0,0,1-1.7,1.774,1.681,1.681,0,0,1-1.808-1.6,1.762,1.762,0,0,1,1.7-1.82,1.681,1.681,0,0,1,1.808,1.646Z",
    transform: "translate(-300.359 -92.607)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5749",
    "data-name": "Path 5749",
    d: "M377.292,132.256c-.22.232-1.553-.765-3.478-.765s-3.292.939-3.478.707.127-.522.73-.962a4.915,4.915,0,0,1,2.805-.846,4.73,4.73,0,0,1,2.747.893C377.211,131.758,377.408,132.175,377.292,132.256Z",
    transform: "translate(-300.669 -93.34)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5750",
    "data-name": "Path 5750",
    d: "M361.232,136.31a1.762,1.762,0,0,1-1.7,1.774,1.681,1.681,0,0,1-1.808-1.6,1.75,1.75,0,0,1,1.7-1.774,1.681,1.681,0,0,1,1.808,1.6Z",
    transform: "translate(-302.669 -92.653)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5751",
    "data-name": "Path 5751",
    d: "M361.193,132.518c-.22.22-1.553-.765-3.478-.777s-3.292.939-3.478.707.116-.51.73-.951a4.915,4.915,0,0,1,2.805-.858,4.637,4.637,0,0,1,2.747.9C361.111,132,361.308,132.414,361.193,132.518Z",
    transform: "translate(-303.232 -93.3)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5752",
    "data-name": "Path 5752",
    d: "M366.233,146.6a12.751,12.751,0,0,1,3.1-.545c.487,0,.939-.139,1.02-.475a2.469,2.469,0,0,0-.313-1.437c-.452-1.159-.927-2.4-1.414-3.7-1.971-5.263-3.4-9.586-3.188-9.668s1.982,4.127,3.953,9.389l1.356,3.721a2.759,2.759,0,0,1,.243,1.9,1.159,1.159,0,0,1-.8.707,3.257,3.257,0,0,1-.823.116,12.751,12.751,0,0,1-3.13-.012Z",
    transform: "translate(-301.445 -93.278)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5753",
    "data-name": "Path 5753",
    d: "M369.7,164.494a35.031,35.031,0,0,1-18.4-4.984s4.428,9.459,18.2,8.242Z",
    transform: "translate(-303.691 -88.705)",
    fill: "#814842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5754",
    "data-name": "Path 5754",
    d: "M362.191,125.719c-.2.51-2.087.255-4.312.522s-4.034.858-4.335.394c-.127-.22.185-.707.916-1.159a7.291,7.291,0,0,1,3.211-1.159,7.2,7.2,0,0,1,3.373.417C361.844,125.116,362.261,125.476,362.191,125.719Z",
    transform: "translate(-303.338 -94.314)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5755",
    "data-name": "Path 5755",
    d: "M376.667,126.645c-.336.429-1.634,0-3.211,0s-2.91.278-3.211-.174c-.139-.22.081-.649.661-1.055a4.405,4.405,0,0,1,2.62-.7,4.451,4.451,0,0,1,2.562.869C376.633,126,376.818,126.436,376.667,126.645Z",
    transform: "translate(-300.682 -94.244)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5756",
    "data-name": "Path 5756",
    d: "M388.47,137.153a9.413,9.413,0,0,0-1.994-6.028,34,34,0,0,1-2.423-2.585c-1.449-2.1-1.09-4.9-1.623-7.407a10.433,10.433,0,0,0-6.074-7.291c-2.539-1.043-5.46-1.066-7.813-2.469-1.739-1.032-3.025-2.747-4.822-3.675-3.478-1.808-7.743-.174-11.221,1.669-.811,2.655.777,5.066,2.318,7.372a9.6,9.6,0,0,0,6.874,4.2c2.145.243,4.637-.128,6.1,1.484s.753,4.486,1.971,6.4c1.727,2.736,6.028,1.936,8.729,3.7,2.087,1.368,2.875,3.988,3.848,6.294s2.724,4.729,5.228,4.729A28.4,28.4,0,0,0,388.47,137.153Z",
    transform: "translate(-303.535 -97.077)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5757",
    "data-name": "Path 5757",
    d: "M360.225,113.444a48.686,48.686,0,0,0-18.547,2.411,8.868,8.868,0,0,0-4.637,2.91,8.786,8.786,0,0,0-1.159,4.718c-.185,5.135,1.577,11.534,3.3,16.391l6.236,4.161c5-.939,3.153-9.586,3.118-13.91a10.131,10.131,0,0,0,6.341-8.636,11.221,11.221,0,0,0,5.344-8.045Z",
    transform: "translate(-306.148 -96.054)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5758",
    "data-name": "Path 5758",
    d: "M345.2,138.63c0-2.956-3.64-3.7-6.236-2.318-1.426.765-2.55,2.318-2.527,5.483.07,8.358,8.439,6.561,8.45,6.318S345.3,142.085,345.2,138.63Z",
    transform: "translate(-306.057 -92.504)",
    fill: "#ab645b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5759",
    "data-name": "Path 5759",
    d: "M342.056,144.615a3.1,3.1,0,0,1-.394.22,1.426,1.426,0,0,1-1.09,0,3.628,3.628,0,0,1-1.692-3.223,4.856,4.856,0,0,1,.394-2.087,1.681,1.681,0,0,1,1.078-1.159.753.753,0,0,1,.869.394c.116.232.058.406.1.417s.174-.139.1-.487a.927.927,0,0,0-.325-.522,1.159,1.159,0,0,0-.811-.209,2.075,2.075,0,0,0-1.507,1.31,4.914,4.914,0,0,0-.487,2.318c.07,1.681.939,3.257,2.156,3.593a1.53,1.53,0,0,0,1.321-.232C342.045,144.823,342.079,144.638,342.056,144.615Z",
    transform: "translate(-305.761 -92.136)",
    fill: "#814842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5760",
    "data-name": "Path 5760",
    d: "M339.6,153.6a7.071,7.071,0,0,1-1.333-.162,4.567,4.567,0,0,1-1.437-.51h.1a4.15,4.15,0,0,1-6.723,2.318h.139a1.658,1.658,0,0,1-1.159.672,2.318,2.318,0,0,1-1.345-.174,2.156,2.156,0,0,1-1.043-.939,2.875,2.875,0,0,1-.348-1.391,4.289,4.289,0,0,1,1.043-2.736,12.891,12.891,0,0,1,2.318-2.029v.2a2.944,2.944,0,0,1-1.217-2.04,4.185,4.185,0,0,1,.359-2.446,6.491,6.491,0,0,1,1.553-2.005,19.175,19.175,0,0,1,2.052-1.565v.185a3.165,3.165,0,0,1-.707-2.457,4.637,4.637,0,0,1,1.066-2.434,11.163,11.163,0,0,1,4.2-2.631l-.07.139a5.541,5.541,0,0,1,6.341-6.538l-.139.139a4.961,4.961,0,0,1,4.927-5.553l-.1.1a4.807,4.807,0,0,1,5.541-4.335l-.093.081a4.637,4.637,0,0,1,.777-2.11,5.8,5.8,0,0,1,1.345-1.461,4.753,4.753,0,0,1,2.91-1.09h.6a1,1,0,0,1,.522.093,4.768,4.768,0,0,1,.788.267l.452.22a.155.155,0,0,1,.151.081l-.162-.07-.464-.2a7.285,7.285,0,0,0-.777-.232,1.224,1.224,0,0,1-.522-.081h-.591a4.787,4.787,0,0,0-2.828,1.159,5.8,5.8,0,0,0-1.3,1.449,4.462,4.462,0,0,0-.742,2.029v.1H353.6a4.637,4.637,0,0,0-5.355,4.173v.1h-.1a4.776,4.776,0,0,0-4.637,5.309v.162h-.162a5.3,5.3,0,0,0-6.063,6.26v.093h-.093a10.849,10.849,0,0,0-4.1,2.573,4.254,4.254,0,0,0-1.009,2.318,2.875,2.875,0,0,0,.638,2.26l.1.1-.127.081a9.841,9.841,0,0,0-3.478,3.478,4,4,0,0,0-.348,2.318,2.678,2.678,0,0,0,1.159,1.878l.139.093-.139.1a12.1,12.1,0,0,0-2.318,1.982,4.092,4.092,0,0,0-1.009,2.585,2.318,2.318,0,0,0,1.264,2.144,1.843,1.843,0,0,0,2.237-.429l.058-.081.081.07a3.976,3.976,0,0,0,6.457-2.191v-.093h.081a4.823,4.823,0,0,0,1.391.51,6.028,6.028,0,0,0,1.31.162,4.869,4.869,0,0,0,2.052-.29,1.936,1.936,0,0,0,1.008-.765c.139-.255.174-.406.185-.406s0,0,0,.116a1.763,1.763,0,0,1-.128.313,2.028,2.028,0,0,1-1.008.811",
    transform: "translate(-307.647 -96.135)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5761",
    "data-name": "Path 5761",
    d: "M313.689,142.284a2.755,2.755,0,0,1-.29-.522,4.37,4.37,0,0,1-.359-1.669,4.231,4.231,0,0,1,.811-2.585,4.451,4.451,0,0,1,3.107-1.774l-.07.1a5.8,5.8,0,0,1,.951-4.08,5.552,5.552,0,0,1,1.716-1.646,13.306,13.306,0,0,1,2.318-.962,4.531,4.531,0,0,0,1.159-.591,2.794,2.794,0,0,0,.811-.985c.406-.788.58-1.727,1.09-2.562a5.054,5.054,0,0,1,5.193-2.318l-.151.128a6.689,6.689,0,0,1,7.767-7.2l-.151.139a5.865,5.865,0,0,1,9.378-5.031h-.128a7.9,7.9,0,0,1,2.991-1.623,11.674,11.674,0,0,1,3.025-.545,13.911,13.911,0,0,1,4.915.58,9.958,9.958,0,0,1,2.875,1.356,6.053,6.053,0,0,1,.661.533l.209.2s-.3-.255-.9-.672a10.282,10.282,0,0,0-2.875-1.3,14,14,0,0,0-4.869-.522,11.776,11.776,0,0,0-2.979.556,7.848,7.848,0,0,0-2.91,1.6h-.139a5.622,5.622,0,0,0-9,4.834v.162H337.7a6.492,6.492,0,0,0-5.529,1.7,6.584,6.584,0,0,0-1.947,5.216v.174h-.174a4.834,4.834,0,0,0-4.938,2.144c-.487.788-.649,1.716-1.078,2.539a2.991,2.991,0,0,1-.881,1.055,5.042,5.042,0,0,1-1.159.626,13.734,13.734,0,0,0-2.318.927A5.482,5.482,0,0,0,318,131.863a5.6,5.6,0,0,0-.95,3.93v.093h-.081a4.278,4.278,0,0,0-3.025,1.681,4.115,4.115,0,0,0-.823,2.5,4.474,4.474,0,0,0,.313,1.646C313.6,142.1,313.7,142.273,313.689,142.284Z",
    transform: "translate(-309.782 -96.819)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5762",
    "data-name": "Path 5762",
    d: "M386.271,148.308a.8.8,0,0,1,0-.684,1.646,1.646,0,0,1,.51-.672,2.944,2.944,0,0,1,1.055-.464,5,5,0,0,0,1.333-.475,2.608,2.608,0,0,0,1-1.3,4.937,4.937,0,0,0,.313-1.889c0-.7-.07-1.426,0-2.2a22.454,22.454,0,0,1,1.31-4.869,7.175,7.175,0,0,0,.243-2.736,3.3,3.3,0,0,0-1.391-2.411,12.2,12.2,0,0,0-2.875-1.159,5.077,5.077,0,0,1-1.461-.777,3.478,3.478,0,0,1-.985-1.368,16.078,16.078,0,0,1-.707-3.315,5.913,5.913,0,0,0-.5-1.611,2.55,2.55,0,0,0-1.159-1.159,9.829,9.829,0,0,0-2.318-.429,3.813,3.813,0,0,1-1.159-.348,2.411,2.411,0,0,1-.881-.823,8.115,8.115,0,0,1-.765-2.179,5.251,5.251,0,0,0-.951-1.924,5.031,5.031,0,0,0-3.536-1.913,5.124,5.124,0,0,0-3.6,1.159l-.116.093v-.139a7.94,7.94,0,0,0-4.729-4.509,7.373,7.373,0,0,0-2.77-.383,6.955,6.955,0,0,0-2.318.522,5.877,5.877,0,0,0-2.55,2.121,5.8,5.8,0,0,0-.452.765l-.1.2v-.012l.093-.209a4.7,4.7,0,0,1,.429-.777,5.715,5.715,0,0,1,2.539-2.2,6.956,6.956,0,0,1,2.318-.556,7.454,7.454,0,0,1,2.84.359,8.114,8.114,0,0,1,4.88,4.637h-.174a5.332,5.332,0,0,1,3.756-1.159,5.228,5.228,0,0,1,3.709,1.994,5.332,5.332,0,0,1,1.008,2.017,8.034,8.034,0,0,0,.73,2.1,2.423,2.423,0,0,0,1.866,1.055,9.575,9.575,0,0,1,2.318.452,2.829,2.829,0,0,1,1.3,1.252,5.891,5.891,0,0,1,.556,1.588,16.23,16.23,0,0,0,.7,3.269,3.083,3.083,0,0,0,.916,1.275,5.078,5.078,0,0,0,1.379.73,12.323,12.323,0,0,1,2.921,1.159,3.3,3.3,0,0,1,1.043,1.159,4.242,4.242,0,0,1,.44,1.426,6.955,6.955,0,0,1-.267,2.828,22.385,22.385,0,0,0-1.322,4.822c0,.753,0,1.5,0,2.191a5.542,5.542,0,0,1-.336,1.947,2.794,2.794,0,0,1-1.078,1.345,4.707,4.707,0,0,1-1.356.464,2.979,2.979,0,0,0-1.043.429,1.623,1.623,0,0,0-.51.626A1.159,1.159,0,0,0,386.271,148.308Z",
    transform: "translate(-302.831 -96.641)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5763",
    "data-name": "Path 5763",
    d: "M403.308,137.032a.776.776,0,0,1-.081-.162,1.684,1.684,0,0,0-.209-.475q-.255-.661-.765-1.843c-.336-.811-.707-1.808-1.263-2.9a7.372,7.372,0,0,0-2.643-3.13c-.649-.406-1.414-.684-2.179-1.066a5.505,5.505,0,0,1-1.159-.719,2.909,2.909,0,0,1-.788-1.159,28.013,28.013,0,0,1-.591-2.77,2.4,2.4,0,0,0-.742-1.159,4.846,4.846,0,0,0-1.31-.684,8.355,8.355,0,0,1-1.449-.638,2.655,2.655,0,0,1-1.078-1.229,12.065,12.065,0,0,1-.545-3.269,4,4,0,0,0-.487-1.553,2.028,2.028,0,0,0-1.275-.939c-1.078-.278-2.318,0-3.478-.209a2.979,2.979,0,0,1-1.565-.927,8.115,8.115,0,0,1-.962-1.484,15.377,15.377,0,0,0-.846-1.484,3.165,3.165,0,0,0-1.159-1.159,4.926,4.926,0,0,0-3.141-.128,7.187,7.187,0,0,1-3.176.116,8.439,8.439,0,0,1-2.689-1.379,14.4,14.4,0,0,0-2.388-1.484,8.613,8.613,0,0,0-4.938-.406,9.274,9.274,0,0,0-3.744,1.7,10.154,10.154,0,0,0-2.144,2.318,11.185,11.185,0,0,0-.951,1.739l-.22.475a1.655,1.655,0,0,1-.081.162,1.155,1.155,0,0,1,.058-.174l.2-.475a10.065,10.065,0,0,1,.916-1.785,10.188,10.188,0,0,1,2.133-2.318,9.274,9.274,0,0,1,3.8-1.762,8.717,8.717,0,0,1,5.054.383,14.48,14.48,0,0,1,2.434,1.5,8.114,8.114,0,0,0,2.62,1.345,7.291,7.291,0,0,0,3.072-.128,10.862,10.862,0,0,1,1.634-.209,3.223,3.223,0,0,1,2.933,1.507,14.85,14.85,0,0,1,.858,1.507A7.4,7.4,0,0,0,381.91,112a2.678,2.678,0,0,0,1.426.858c1.159.243,2.318-.081,3.478.209a2.319,2.319,0,0,1,1.426,1.043,4.37,4.37,0,0,1,.51,1.658,12.229,12.229,0,0,0,.522,3.2,2.423,2.423,0,0,0,.985,1.159,8.428,8.428,0,0,0,1.4.614,4.566,4.566,0,0,1,1.368.73,2.654,2.654,0,0,1,.823,1.287c.267.962.232,1.936.568,2.77a3.477,3.477,0,0,0,1.785,1.75c.753.383,1.519.672,2.191,1.09a7.453,7.453,0,0,1,2.678,3.211c.545,1.159.9,2.121,1.229,2.921l.73,1.866.174.487A1.16,1.16,0,0,1,403.308,137.032Z",
    transform: "translate(-303.061 -97.466)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5764",
    "data-name": "Path 5764",
    d: "M392.066,124.66h.151a.881.881,0,0,1,.44.116,1.808,1.808,0,0,1,.753,1.519,4.638,4.638,0,0,1-.243,1.24,5.366,5.366,0,0,0-.29,1.426,3.28,3.28,0,0,0,.51,1.565c.3.522.7,1.032,1,1.646a2.4,2.4,0,0,1,.1,2.11c-.3.7-.846,1.264-1.159,1.971a3.083,3.083,0,0,0,.116,2.318c.278.777.707,1.53.985,2.4a3.593,3.593,0,0,1,.2,1.368,3.317,3.317,0,0,1-.383,1.356,16.225,16.225,0,0,1-1.692,2.318,3.837,3.837,0,0,0-1.02,2.6,13.227,13.227,0,0,0,.869,2.863,4.3,4.3,0,0,1,.243,1.542,3.652,3.652,0,0,1-.464,1.484,12.613,12.613,0,0,1-1.924,2.26,6.816,6.816,0,0,0-1.565,2.318,20.422,20.422,0,0,1-1,2.55,3.025,3.025,0,0,1-.893,1.02,4.056,4.056,0,0,1-1.159.51,9.327,9.327,0,0,0-1.159.348,3.918,3.918,0,0,0-.985.614,8.5,8.5,0,0,0-1.461,1.716c-.406.591-.8,1.159-1.217,1.716a5.8,5.8,0,0,1-3.014,1.994,6.19,6.19,0,0,1-2.724.128,5.994,5.994,0,0,1-1.646-.568,3.757,3.757,0,0,1-.5-.336,5.947,5.947,0,0,0,2.156.8,6.039,6.039,0,0,0,2.678-.162,5.587,5.587,0,0,0,2.91-1.971c.406-.522.788-1.159,1.159-1.716a8.754,8.754,0,0,1,1.484-1.762,4.034,4.034,0,0,1,1.043-.649,11.111,11.111,0,0,1,1.159-.371,3.664,3.664,0,0,0,1.159-.487,2.7,2.7,0,0,0,.823-.939,18.892,18.892,0,0,0,.962-2.515,7.177,7.177,0,0,1,1.623-2.376,12.253,12.253,0,0,0,1.878-2.214,3.374,3.374,0,0,0,.429-1.368,4.266,4.266,0,0,0-.22-1.461,12.356,12.356,0,0,1-.881-2.921,3.153,3.153,0,0,1,.255-1.576,5.647,5.647,0,0,1,.788-1.264,17.38,17.38,0,0,0,1.681-2.249,3.153,3.153,0,0,0,.359-1.275,3.663,3.663,0,0,0-.185-1.275c-.267-.835-.684-1.6-.974-2.4a3.338,3.338,0,0,1-.1-2.457c.325-.753.869-1.31,1.159-1.971a2.2,2.2,0,0,0-.081-1.947c-.29-.591-.672-1.159-.974-1.646a3.478,3.478,0,0,1-.51-1.646,5.322,5.322,0,0,1,.313-1.461,4.243,4.243,0,0,0,.255-1.159,1.739,1.739,0,0,0-.684-1.472A1.159,1.159,0,0,0,392.066,124.66Z",
    transform: "translate(-300.246 -94.252)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5765",
    "data-name": "Path 5765",
    d: "M314.357,143.108a3.338,3.338,0,0,1-.649-.093,4.544,4.544,0,0,1-1.727-.846,4.486,4.486,0,0,1-1.634-2.539,4.637,4.637,0,0,1,.869-3.895,12.458,12.458,0,0,1,1.75-1.634,5.6,5.6,0,0,0,1.634-1.913,3.732,3.732,0,0,0,0-2.655c-.278-.9-.73-1.808-.985-2.805a8.184,8.184,0,0,1,6.654-10.108l-.081.2a4.08,4.08,0,0,1-.638-1.855,5.228,5.228,0,0,1,.22-1.982,5.8,5.8,0,0,1,.927-1.785,6.561,6.561,0,0,1,1.484-1.4,12.867,12.867,0,0,1,5.587-1.947,19.706,19.706,0,0,1,5.61,0l-.139.116a5.912,5.912,0,0,1,6.538-5.39,9.575,9.575,0,0,1,2.7.858,5.8,5.8,0,0,0,1.275.359,3.558,3.558,0,0,0,1.263-.07,9.992,9.992,0,0,0,2.249-.974,8.9,8.9,0,0,1,2.156-.858,7.372,7.372,0,0,1,2.11-.185,7.036,7.036,0,0,1,3.42,1.159,7.35,7.35,0,0,1,1.947,1.855,7.452,7.452,0,0,1,.8,1.472,4.732,4.732,0,0,1,.185.556s-.07-.185-.22-.533a7.626,7.626,0,0,0-.835-1.449,7.233,7.233,0,0,0-1.947-1.8,7.152,7.152,0,0,0-5.425-.869,8.971,8.971,0,0,0-2.11.858,9.807,9.807,0,0,1-2.318,1,3.477,3.477,0,0,1-1.333.081,5.8,5.8,0,0,1-1.31-.359,9.576,9.576,0,0,0-2.655-.835,5.912,5.912,0,0,0-2.84.417,5.7,5.7,0,0,0-3.478,4.764v.139h-.127a19.265,19.265,0,0,0-5.541,0,12.751,12.751,0,0,0-5.483,1.913,6.839,6.839,0,0,0-1.426,1.345,5.6,5.6,0,0,0-.881,1.716,4.694,4.694,0,0,0-.209,1.878,3.884,3.884,0,0,0,.591,1.739l.1.162h-.2a7.975,7.975,0,0,0-6.48,9.807c.255.974.7,1.878.974,2.805a3.929,3.929,0,0,1,0,2.794,5.889,5.889,0,0,1-1.716,1.959,11.035,11.035,0,0,0-1.739,1.6,4.555,4.555,0,0,0-.869,3.767,4.347,4.347,0,0,0,1.565,2.492,4.636,4.636,0,0,0,1.681.869C314.137,143.073,314.357,143.1,314.357,143.108Z",
    transform: "translate(-310.229 -97.909)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5766",
    "data-name": "Path 5766",
    d: "M398.515,123.26v-.638c0-.429,0-1.032-.07-1.8s-.116-1.75-.267-2.852a16.469,16.469,0,0,0-.927-3.64,10.722,10.722,0,0,0-2.481-3.779,7.755,7.755,0,0,0-2.075-1.426,21.915,21.915,0,0,0-2.55-.869,7.489,7.489,0,0,1-2.573-1.3,11.525,11.525,0,0,1-2.017-2.214c-.614-.8-1.159-1.658-1.866-2.434a8.3,8.3,0,0,0-2.411-1.971,15.243,15.243,0,0,0-5.958-1.576,38.808,38.808,0,0,0-5.8,0,29.593,29.593,0,0,0-9.552,2.168,20.866,20.866,0,0,0-5.61,3.478l-.777.7-.533.545-.336.336c-.07.081-.116.116-.116.1l.1-.116.313-.359.51-.568.765-.707a20.32,20.32,0,0,1,5.61-3.559,29.373,29.373,0,0,1,9.6-2.249,39.41,39.41,0,0,1,5.8,0,15.127,15.127,0,0,1,6.063,1.6,9.111,9.111,0,0,1,2.481,2.017c.684.8,1.264,1.658,1.866,2.469a12.2,12.2,0,0,0,1.971,2.168,7.454,7.454,0,0,0,2.492,1.264,20.4,20.4,0,0,1,2.573.893,8.021,8.021,0,0,1,2.133,1.472,10.931,10.931,0,0,1,2.492,3.86,16.136,16.136,0,0,1,.9,3.7c.139,1.159.2,2.063.22,2.852s0,1.4,0,1.808v.475A.689.689,0,0,1,398.515,123.26Z",
    transform: "translate(-303.484 -98.428)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5767",
    "data-name": "Path 5767",
    d: "M358.852,148.107a3.164,3.164,0,0,1,1.982-2.527,2.77,2.77,0,0,1,3.037.869,2.492,2.492,0,0,1,0,2.967,2.736,2.736,0,0,1-1.252.974,3.559,3.559,0,0,1-2.028.081,2.318,2.318,0,0,1-1.4-.893,2.179,2.179,0,0,1-.336-1.472Z",
    transform: "translate(-302.492 -90.946)",
    fill: "#814842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5768",
    "data-name": "Path 5768",
    d: "M360.067,144.31c.313,0,0,2.1,1.553,3.825s3.791,1.843,3.756,2.133-.545.325-1.484.209a5.17,5.17,0,0,1-3.153-1.658,4.5,4.5,0,0,1-1.159-3.188C359.615,144.751,359.928,144.275,360.067,144.31Z",
    transform: "translate(-302.373 -91.124)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5769",
    "data-name": "Path 5769",
    d: "M343.54,151.716a21.1,21.1,0,0,0-2.9-6.236l-.533-.29a14.328,14.328,0,0,0-2.852,5.077,4.845,4.845,0,0,0,1.7,5.216,3.779,3.779,0,0,0,2.6.522,2.771,2.771,0,0,0,1.785-.951A3.814,3.814,0,0,0,343.54,151.716Z",
    transform: "translate(-305.958 -90.984)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18140",
    "data-name": "Rectangle 18140",
    width: 46.414,
    height: 32.214,
    rx: 2.14,
    transform: "translate(44.595 246.851)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5770",
    "data-name": "Path 5770",
    d: "M366.608,325.285l-2.388,5.471h-1.252l-2.318-5.506h1.368l1.681,3.93,1.7-3.93Z",
    transform: "translate(-302.203 -62.321)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5771",
    "data-name": "Path 5771",
    d: "M365.561,328.537a2.318,2.318,0,1,1,2.318,2.179,2.179,2.179,0,0,1-2.318-2.179Zm3.408,0a1.09,1.09,0,1,0-1.078,1.159,1.066,1.066,0,0,0,1.078-1.159Z",
    transform: "translate(-301.422 -62.189)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5772",
    "data-name": "Path 5772",
    d: "M373.074,330.531a1.681,1.681,0,0,1-1,.267,1.391,1.391,0,0,1-1.576-1.519v-1.739h-.661V326.6h.661V325.57h1.229V326.6h1.055v.939h-1.055v1.727a.487.487,0,0,0,.522.556.823.823,0,0,0,.5-.162Z",
    transform: "translate(-300.74 -62.27)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5773",
    "data-name": "Path 5773",
    d: "M377.286,328.848h-3.2a1.159,1.159,0,0,0,1.159.846,1.426,1.426,0,0,0,1.066-.406l.661.707a2.481,2.481,0,0,1-4.173-1.5,2.156,2.156,0,0,1,2.318-2.179,2.1,2.1,0,0,1,2.2,2.2C377.309,328.616,377.3,328.744,377.286,328.848Zm-3.211-.719h2.075a1.055,1.055,0,0,0-2.075,0Z",
    transform: "translate(-300.269 -62.152)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5774",
    "data-name": "Path 5774",
    d: "M366.135,302.687,347.24,252.1l21.491-5.61,9.61,53.879Z",
    transform: "translate(-304.337 -74.859)",
    fill: "#ab645b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5775",
    "data-name": "Path 5775",
    d: "M375.947,330.418l7.314-8.59.916-11.29L375.727,293H363.938s-1.681,6.445-1.066,9.192,1.681,8.821,1.681,8.821l.916,6.573-1.379,2.747-2.318,2.446s.243,2.133,2.226,1.518a13.91,13.91,0,0,0,4.417-3.153l1.831-4.312v4.312l-4.88,4.834s.464,2.318,2.318,1.681l1.831-.614s.3,1.831,2.434,1.217a22.025,22.025,0,0,0,3.86-1.518,3,3,0,0,0,.139,3.675Z",
    transform: "translate(-302.024 -67.455)",
    fill: "#ab645b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5776",
    "data-name": "Path 5776",
    d: "M374.8,307.75a14.477,14.477,0,0,1,.417,3c.093.939.185,2.052.267,3.292,0,.626.07,1.275.1,1.936a15.064,15.064,0,0,1,0,2.179,8.335,8.335,0,0,1-2.527,3.28,16.224,16.224,0,0,1-2.7,1.959,20.539,20.539,0,0,1-2.631,1.507,11.684,11.684,0,0,1,2.4-1.855,21.429,21.429,0,0,0,2.55-2.005A8.4,8.4,0,0,0,375,318.009,19.39,19.39,0,0,0,375,316a17.681,17.681,0,0,0-.07-1.936l-.139-3.28A16.543,16.543,0,0,1,374.8,307.75Z",
    transform: "translate(-301.076 -65.107)",
    fill: "#814842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5777",
    "data-name": "Path 5777",
    d: "M378.7,308a13.1,13.1,0,0,1,.649,2.771c.162.869.336,1.9.51,3.049.093.58.174,1.159.267,1.808a16.616,16.616,0,0,1,.186,2.029,7.883,7.883,0,0,1-2.1,3.292,15.893,15.893,0,0,1-2.318,2.04,18.837,18.837,0,0,1-2.318,1.611,10.029,10.029,0,0,1,2.087-1.936,19.871,19.871,0,0,0,2.2-2.087,7.766,7.766,0,0,0,1.924-3.014,18.641,18.641,0,0,0-.174-1.866c-.07-.614-.151-1.217-.22-1.8q-.209-1.658-.383-3.06A13.431,13.431,0,0,1,378.7,308Z",
    transform: "translate(-300.144 -65.067)",
    fill: "#814842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5778",
    "data-name": "Path 5778",
    d: "M342.778,166.831c-1.542,1.924-10.757,10.954-13.458,32.457s-6.631,60.533-2.724,64.694c3.327,3.536,11.592-1.159,11.592-1.159l11.267,1.437,42.588,3.2s4.637,1.159,4.637-8.114,8.474-33.095,3.083-45.023-18.895-28.145-18.895-28.145l-5.008-8.114-.383-5.8L343.091,162.16Z",
    transform: "translate(-307.885 -88.283)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5779",
    "data-name": "Path 5779",
    d: "M342.7,175.9c-4.486,3.953-9.4,11.186-8.311,23.555,1.924,21.943,9.273,61.958,15,73.5l26.557-2.689-7.314-29.246s.777-44.64,1.159-48.489c.22-2.179-2.133-9.273-6.584-14.583",
    transform: "translate(-306.407 -86.096)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5780",
    "data-name": "Path 5780",
    d: "M363.237,177.96a22.2,22.2,0,0,1,2.794,3.825,32.831,32.831,0,0,1,2.539,5.054,24.464,24.464,0,0,1,1.159,3.408,8.973,8.973,0,0,1,.29,1.971q0,1.032-.1,2.087c-.359,11.383-.614,27.565-.939,46.727v-.093c2.26,8.984,4.741,18.872,7.338,29.246l.081.336h-.336l-16.46,1.716-10.143,1.02h-.209l-.093-.185a68.4,68.4,0,0,1-3.57-9.923c-.951-3.315-1.8-6.607-2.55-9.853-1.53-6.48-2.782-12.751-3.883-18.732-2.156-11.974-3.7-22.743-4.637-31.808a41.513,41.513,0,0,1,0-12.253,25.827,25.827,0,0,1,3.13-8.659,23.974,23.974,0,0,1,3.535-4.637,15.918,15.918,0,0,1,1.5-1.356s-.116.139-.348.371-.614.591-1.055,1.066a25.32,25.32,0,0,0-3.478,4.637,26.175,26.175,0,0,0-3,8.613,41.51,41.51,0,0,0,.058,12.16c.962,9.03,2.55,19.8,4.741,31.738,1.159,5.97,2.388,12.241,3.918,18.709q1.159,4.845,2.55,9.818a67.236,67.236,0,0,0,3.547,9.818l-.3-.162,10.131-1.032,16.426-1.669-.267.371c-2.585-10.433-5.042-20.263-7.291-29.246v-.081c.371-19.161.7-35.344,1.159-46.727a13.91,13.91,0,0,0-1.217-7.361,36.514,36.514,0,0,0-2.457-5.066,34.292,34.292,0,0,0-1.924-2.933l-.545-.719Q363.273,178.06,363.237,177.96Z",
    transform: "translate(-306.436 -86.104)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5781",
    "data-name": "Path 5781",
    d: "M372.2,172.161a10.434,10.434,0,0,1-.684,1.3c-.44.835-1.078,2.052-1.8,3.57l-.081.151h-.162a113.867,113.867,0,0,1-12.345-3.478c-4.787-1.634-9.03-3.373-12.056-4.718-1.519-.672-2.736-1.24-3.559-1.658a6.8,6.8,0,0,1-1.264-.707,6.885,6.885,0,0,1,1.356.487l3.628,1.484c3.06,1.24,7.314,2.91,12.09,4.544s9.053,2.863,12.241,3.675l-.243.1c.788-1.507,1.472-2.689,1.994-3.478A5.135,5.135,0,0,1,372.2,172.161Z",
    transform: "translate(-305.45 -87.573)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10678",
    "data-name": "Group 10678",
    transform: "translate(40.329 81.724)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5782",
    "data-name": "Path 5782",
    d: "M352.01,172.489c6.12,2.921,12.253,5.8,18.338,8.81.243-2.979.475-5.97.707-8.949a12.843,12.843,0,0,0-2.434,4.637,3.686,3.686,0,0,0-2.457-1.426c-4.382-1.159-8.961-1.658-13.11-3.478-1.461-.626-2.863-1.391-4.312-2.052a20.214,20.214,0,0,0-2.156-.835c-.394-.128-1.159-.452-1.565-.128.278.359,1.159.568,1.519.765l1.866.893Z",
    transform: "translate(-345.02 -168.929)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10679",
    "data-name": "Group 10679",
    transform: "translate(26.279 108.792)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5783",
    "data-name": "Path 5783",
    d: "M334.906,200.07l-.452-7.79c-4.208,22.546.359,45.394,10.885,65.772C341.629,238.9,337.514,221.364,334.906,200.07Z",
    transform: "translate(-332.899 -192.28)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-56",
    transform: "translate(69.387 172.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5784",
    "data-name": "Path 5784",
    d: "M173.08,275.19l41.545,1.553.893,12.9L179.1,298.293Z",
    transform: "translate(-49.742 -135.147)",
    fill: "#ac815f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5785",
    "data-name": "Path 5785",
    d: "M203,281.691l7.732,9.471s5.935-2.492,8.636-6.341,14.281-7.685,14.281-7.685,3.93,1.669,4.451.406-1.008-2.469-1.008-2.469,2.017-1.1,1.843-2.573-3.025-1.82-3.025-1.82,2.446-1.565,1.5-2.782-10.433-2.237-10.433-2.237l-9.053,3.176a3.849,3.849,0,0,0-1.739,1.264l-6.341,8.114Z",
    transform: "translate(-44.98 -136.664)",
    fill: "#ac815f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5786",
    "data-name": "Path 5786",
    d: "M234.544,269.43a2.18,2.18,0,0,1-.568.429,5.54,5.54,0,0,1-1.866.614,9.573,9.573,0,0,1-2.91-.07c-1.078-.127-2.249-.51-3.478-.591a5.564,5.564,0,0,0-3.141,1.066c-.9.568-1.692,1.159-2.434,1.53a4.638,4.638,0,0,1-1.878.591,1.878,1.878,0,0,1-.719-.058,6.4,6.4,0,0,0,2.446-.823c.684-.394,1.449-1,2.318-1.6a5.8,5.8,0,0,1,3.4-1.159,11.19,11.19,0,0,1,1.832.3c.568.127,1.159.243,1.646.336a9.876,9.876,0,0,0,2.794.151,7.8,7.8,0,0,0,2.562-.719Z",
    transform: "translate(-42.664 -136.075)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5787",
    "data-name": "Path 5787",
    d: "M230.17,273.207c0-.116.626,0,1.333.1s1.31.162,1.31.3-.614.267-1.379.151S230.124,273.323,230.17,273.207Z",
    transform: "translate(-40.655 -135.47)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18141",
    "data-name": "Rectangle 18141",
    width: 46.414,
    height: 32.214,
    rx: 1.82,
    transform: "translate(175.252 162.701) rotate(-82.35)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5788",
    "data-name": "Path 5788",
    d: "M218.119,298.955a2.318,2.318,0,0,0,.406,1.449c.545,1,2.226.869,4.115,1.159l16.333,2.11,5.413.707,2.875.383a2.422,2.422,0,0,0,1.356,0,1.924,1.924,0,0,0,.974-.869,1.786,1.786,0,0,0,.209-.649l.1-.765.209-1.553c.139-1.055.278-2.11.417-3.2q.441-3.234.881-6.654c1.159-9.111,2.55-19.127,3.953-29.629a1.831,1.831,0,0,0-.533-1.553,2.446,2.446,0,0,0-1.646-.568l-3.872-.522-7.558-1.02-14.293-1.936c-.545-.07-1.159-.185-1.658-.209a1.866,1.866,0,0,0-1.31.568,2.11,2.11,0,0,0-.545,1.368c-.07.545-.139,1.09-.22,1.623q-.429,3.234-.858,6.283c-.556,4.046-1.078,7.813-1.542,11.256-.962,6.862-1.75,12.426-2.318,16.31-.278,1.889-.5,3.373-.649,4.428-.081.475-.139.858-.185,1.159a2.4,2.4,0,0,1-.081.394,2.135,2.135,0,0,1,0-.406c0-.29.07-.672.128-1.159.128-1.055.3-2.55.533-4.451.5-3.895,1.217-9.459,2.1-16.321.452-3.478.951-7.233,1.472-11.279q.394-3.037.835-6.283l.209-1.623a2.631,2.631,0,0,1,.684-1.669,2.4,2.4,0,0,1,1.7-.753,13.472,13.472,0,0,1,1.739.209l14.293,1.9,7.558,1.008,3.872.522a7.515,7.515,0,0,1,1.02.174,2.319,2.319,0,0,1,.962.568,2.411,2.411,0,0,1,.719,2.052c-1.426,10.514-2.77,20.529-4.011,29.64q-.452,3.408-.9,6.654c-.139,1.078-.29,2.133-.429,3.188-.07.522-.151,1.032-.22,1.553l-.1.765a2.457,2.457,0,0,1-.255.811,2.411,2.411,0,0,1-1.252,1.159,3.025,3.025,0,0,1-1.6,0l-2.875-.394-5.4-.742-16.3-2.318-2.562-.371a2.225,2.225,0,0,1-1.623-.962,1.855,1.855,0,0,1-.267-1.542Z",
    transform: "translate(-42.583 -138.348)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5789",
    "data-name": "Path 5789",
    d: "M238.277,275.04l-5.147-3.1.162-1.252,5.8-1.623-.185,1.368-4.127,1.159,3.675,2.214Z",
    transform: "translate(-40.183 -136.121)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5790",
    "data-name": "Path 5790",
    d: "M235.043,273.613a2.318,2.318,0,1,1-2.481,2.017,2.191,2.191,0,0,1,2.481-2.017Zm-.464,3.373a1.09,1.09,0,1,0-1.008-1.229,1.055,1.055,0,0,0,1.008,1.229Z",
    transform: "translate(-40.277 -135.401)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5791",
    "data-name": "Path 5791",
    d: "M232.142,280.787a1.774,1.774,0,0,1-.139-1.032,1.4,1.4,0,0,1,1.716-1.368l1.727.232.093-.649.939.128-.093.649,1.02.139-.162,1.217-1.02-.139-.139,1.043-.939-.128.139-1.043-1.7-.232a.5.5,0,0,0-.626.452.753.753,0,0,0,.093.51Z",
    transform: "translate(-40.367 -134.704)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5792",
    "data-name": "Path 5792",
    d: "M233.139,285.173l.429-3.176a1.159,1.159,0,0,0-1.008,1.09,1.437,1.437,0,0,0,.267,1.159l-.788.556a2.237,2.237,0,0,1-.452-1.82,2.214,2.214,0,0,1,2.492-2.11,2.156,2.156,0,0,1,1.855,2.527,2.1,2.1,0,0,1-2.469,1.9Zm1.159-3.1-.278,2.063a1.008,1.008,0,0,0,1.02-.916,1,1,0,0,0-.765-1.148Z",
    transform: "translate(-40.436 -134.245)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5793",
    "data-name": "Path 5793",
    d: "M209.65,288.948c.452-.128,4.532-.51,7.314-2.087s6.48-6.491,6.48-6.491,9.273-2.388,10.189-4.359-.383-4.08-3.2-3.478a86.454,86.454,0,0,0-8.879,2.828l-5.912.1C215.191,275.409,209.65,288.948,209.65,288.948Z",
    transform: "translate(-43.921 -135.586)",
    fill: "#ac815f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5794",
    "data-name": "Path 5794",
    d: "M216.86,275.437a7.967,7.967,0,0,1,1.229-.093l3.478-.116h0c2.029-.765,4.706-1.785,7.917-2.666a5.8,5.8,0,0,1,2.631-.255,2.492,2.492,0,0,1,2.04,1.913,2.794,2.794,0,0,1-.093,1.507,2.48,2.48,0,0,1-.916,1.24,12.971,12.971,0,0,1-2.666,1.391,57.881,57.881,0,0,1-6.955,2.26l.128-.081a37.876,37.876,0,0,1-4.579,5.031,10.432,10.432,0,0,1-2.376,1.669,13.657,13.657,0,0,1-2.318.893,24.525,24.525,0,0,1-3.478.719l-.927.116h-.325c0-.116,1.762-.255,4.637-1.159a14.579,14.579,0,0,0,2.249-.916,10.907,10.907,0,0,0,2.318-1.669,40.574,40.574,0,0,0,4.474-5.008v-.07h.07a58.4,58.4,0,0,0,6.862-2.318,12.438,12.438,0,0,0,2.562-1.333,2.237,2.237,0,0,0,.858-2.318,2.063,2.063,0,0,0-1.7-1.588,5.449,5.449,0,0,0-2.434.22c-3.188.846-5.889,1.832-7.929,2.539h-3.478a9.512,9.512,0,0,1-1.275.093Z",
    transform: "translate(-43.921 -135.614)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5795",
    "data-name": "Path 5795",
    d: "M280.9,398.64l5.147,25.282s27.426,3.246,28.829,7.824L266.194,443.5l-9.644-39.053Z",
    transform: "translate(-36.455 -115.495)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10680",
    "data-name": "Group 10680",
    transform: "translate(220.095 283.145)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5796",
    "data-name": "Path 5796",
    d: "M280.9,398.64l5.147,25.282s27.426,3.246,28.829,7.824L266.194,443.5l-9.644-39.053Z",
    transform: "translate(-256.55 -398.64)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5797",
    "data-name": "Path 5797",
    d: "M268.718,421.788a2.052,2.052,0,0,0-.823,2.608,1.971,1.971,0,0,0,2.573.835,2.168,2.168,0,0,0,.858-2.759,2.052,2.052,0,0,0-2.771-.58",
    transform: "translate(-34.678 -111.843)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5798",
    "data-name": "Path 5798",
    d: "M265.029,439.229l-.939-3.791,47.074-9.969s2.4.417,2.515,2.005Z",
    transform: "translate(-35.255 -111.224)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5799",
    "data-name": "Path 5799",
    d: "M283.156,420.084c0,.243-1.159.638-2.1,1.681s-1.368,2.191-1.611,2.156-.209-1.507,1-2.747S283.156,419.852,283.156,420.084Z",
    transform: "translate(-32.83 -112.098)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5800",
    "data-name": "Path 5800",
    d: "M287.819,420.838c.116.209-.823.869-1.379,2.063s-.545,2.318-.788,2.318-.707-1.263,0-2.736S287.761,420.607,287.819,420.838Z",
    transform: "translate(-31.883 -111.971)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5801",
    "data-name": "Path 5801",
    d: "M291.334,426.112c-.209.1-.823-1.008-.533-2.457s1.287-2.226,1.437-2.052-.371,1.032-.6,2.226S291.554,426.031,291.334,426.112Z",
    transform: "translate(-31.015 -111.844)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5802",
    "data-name": "Path 5802",
    d: "M281.756,415.268c-.058.243-1.217.174-2.539.591s-2.318,1.09-2.446.916.638-1.264,2.191-1.727S281.826,415.025,281.756,415.268Z",
    transform: "translate(-33.238 -112.916)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5803",
    "data-name": "Path 5803",
    d: "M274.738,404.89l1.936,25.722s26.8,6.654,27.623,11.372l-49.741,5.576L249.92,407.6Z",
    transform: "translate(-37.511 -114.5)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5804",
    "data-name": "Path 5804",
    d: "M259.7,426.725a2.04,2.04,0,0,0-1.159,2.469,1.947,1.947,0,0,0,2.434,1.159,2.168,2.168,0,0,0,1.159-2.631,2.04,2.04,0,0,0-2.678-.916",
    transform: "translate(-36.152 -111.042)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5805",
    "data-name": "Path 5805",
    d: "M253.992,442.781l-.452-3.872,47.944-4s2.318.707,2.249,2.318Z",
    transform: "translate(-36.935 -109.722)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5806",
    "data-name": "Path 5806",
    d: "M274.265,426.8c0,.243-1.159.5-2.318,1.414s-1.634,2.005-1.866,1.936,0-1.519,1.333-2.608S274.3,426.58,274.265,426.8Z",
    transform: "translate(-34.314 -111.036)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5807",
    "data-name": "Path 5807",
    d: "M278.8,428.15c.081.232-.927.765-1.634,1.878s-.823,2.237-1.066,2.249-.556-1.333.359-2.712S278.761,427.918,278.8,428.15Z",
    transform: "translate(-33.385 -110.81)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5808",
    "data-name": "Path 5808",
    d: "M281.607,433.843c-.209.081-.684-1.1-.209-2.492s1.542-2.063,1.669-1.866-.5.974-.869,2.133S281.85,433.8,281.607,433.843Z",
    transform: "translate(-32.532 -110.591)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5809",
    "data-name": "Path 5809",
    d: "M273.445,421.857c-.081.232-1.229,0-2.6.267s-2.388.8-2.527.6.777-1.159,2.388-1.437S273.538,421.649,273.445,421.857Z",
    transform: "translate(-34.584 -111.901)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5810",
    "data-name": "Path 5810",
    d: "M137.521,185.665l2.191,49.091c.371,8.346,2.631,20.529,15.8,19.335h0c11.348-1.889,13.76-12.879,13.412-20.668-.174-3.686-.313-6.77-.3-7.152,0,0,12.45-1.739,12.751-14.142.174-6-.487-18.385-1.159-29.571a23.184,23.184,0,0,0-22.708-21.619h-1.159C143.375,161.473,136.617,172.752,137.521,185.665Z",
    transform: "translate(-55.416 -153.333)",
    fill: "#ac815f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5811",
    "data-name": "Path 5811",
    d: "M166.548,217.984A29.965,29.965,0,0,1,150.47,213s3.791,9.123,16.229,8.207Z",
    transform: "translate(-53.342 -145.046)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5812",
    "data-name": "Path 5812",
    d: "M157.421,185.271c-.232.267-1.727-.8-3.791-.73s-3.559,1.159-3.791.9.1-.58.753-1.09a5.228,5.228,0,0,1,3.025-1.055,5.008,5.008,0,0,1,3.037.916C157.305,184.691,157.537,185.143,157.421,185.271Z",
    transform: "translate(-53.454 -149.774)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5813",
    "data-name": "Path 5813",
    d: "M156.87,189.041a1.681,1.681,0,0,1-1.646,1.669,1.6,1.6,0,0,1-1.7-1.542,1.669,1.669,0,0,1,1.646-1.658,1.6,1.6,0,0,1,1.7,1.53Z",
    transform: "translate(-52.856 -149.104)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5814",
    "data-name": "Path 5814",
    d: "M161.639,199.334a12.844,12.844,0,0,1,3.107-.5c.487,0,.951-.139,1.032-.464a2.319,2.319,0,0,0-.3-1.449c-.44-1.159-.893-2.434-1.379-3.733-1.913-5.321-3.292-9.679-3.083-9.76s1.947,4.173,3.86,9.482l1.321,3.756a2.793,2.793,0,0,1,.22,1.913,1.229,1.229,0,0,1-.811.707,3.721,3.721,0,0,1-.823.093,11.591,11.591,0,0,1-3.141-.046Z",
    transform: "translate(-51.667 -149.754)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5815",
    "data-name": "Path 5815",
    d: "M156.287,179.484c-.174.475-1.855.22-3.825.44s-3.593.742-3.848.313c-.1-.209.174-.649.823-1.09a6.526,6.526,0,0,1,5.8-.58C156.02,178.881,156.356,179.264,156.287,179.484Z",
    transform: "translate(-53.641 -150.595)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5816",
    "data-name": "Path 5816",
    d: "M173.045,179.773c-.2.383-1.843,0-3.8.116s-3.57.394-3.791,0c-.1-.185.2-.533.858-.869a6.885,6.885,0,0,1,2.875-.649,7.14,7.14,0,0,1,2.91.545C172.825,179.24,173.161,179.587,173.045,179.773Z",
    transform: "translate(-50.96 -150.559)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5817",
    "data-name": "Path 5817",
    d: "M139.408,190.27c-.209-.093-8.485-2.655-8.358,5.8s8.636,6.607,8.648,6.364S139.408,190.27,139.408,190.27Z",
    transform: "translate(-56.433 -148.734)",
    fill: "#ac815f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5818",
    "data-name": "Path 5818",
    d: "M136.764,198.928a3.1,3.1,0,0,1-.394.22,1.53,1.53,0,0,1-1.159,0,3.7,3.7,0,0,1-1.739-3.257,4.868,4.868,0,0,1,.383-2.133,1.692,1.692,0,0,1,1.09-1.159.742.742,0,0,1,.881.394c.116.232.07.406.116.417s.174-.151.1-.5a.985.985,0,0,0-.348-.522,1.159,1.159,0,0,0-.823-.209,2.087,2.087,0,0,0-1.519,1.345,5.077,5.077,0,0,0-.475,2.376c.081,1.7.985,3.292,2.214,3.628a1.53,1.53,0,0,0,1.345-.243C136.752,199.113,136.787,198.928,136.764,198.928Z",
    transform: "translate(-56.142 -148.362)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5819",
    "data-name": "Path 5819",
    d: "M160.766,203.023c.081-.22-1.6-.614-2.863-2.11a9.691,9.691,0,0,1-1.3-2.145c-.278-.6-.487-.974-.58-.939s0,.44.139,1.1a6.2,6.2,0,0,0,1.229,2.423,5.181,5.181,0,0,0,2.318,1.53C160.314,203.1,160.755,203.1,160.766,203.023Z",
    transform: "translate(-52.463 -147.461)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5820",
    "data-name": "Path 5820",
    d: "M127.937,182.838c1.588-3.083,1.8-6.665,2.573-10.062s2.434-6.955,5.634-8.3h.081c2.863-1.345,6.48-1.576,9.007.325.348-4.44,4.011-8.114,8.242-9.517s11.163-1.09,15.371.336c3.269,1.159,6.491,3.547,10.433,7.2a41.847,41.847,0,0,1,4.637,4.984l4.393,11.325-2.852,6.236c-.174.417-.348.846-.568,1.264h0l-2.156,12.913c-.383-3.478-.823-15.579-1.159-19.045a19.382,19.382,0,0,1-14.177-5.587c-2.017-2.005-3.663-4.556-6.271-5.668-3.373-1.426-7.21,0-10.595,1.368l.139-.139a15.336,15.336,0,0,0-4.579,3.733,48.454,48.454,0,0,1-.927,20.518c-.267,1-1.032,3.083-1.982,3.478-1.866.846-2.481-1.066-3.686-2.029a5.066,5.066,0,0,0-3.478-.649,78.018,78.018,0,0,1-2.817-8.659,7.72,7.72,0,0,1-3.547.441l.939-2.678a4.091,4.091,0,0,1-1.472.777,1.391,1.391,0,0,1-1.484-.556C127.207,184.264,127.6,183.487,127.937,182.838Z",
    transform: "translate(-57.006 -154.378)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5821",
    "data-name": "Path 5821",
    d: "M148.537,164.43a12.508,12.508,0,0,0-1.159,1.159,8.8,8.8,0,0,0-1.658,4.208,15.5,15.5,0,0,0-.139,3.165,30.461,30.461,0,0,0,.383,3.628,34.045,34.045,0,0,1,.325,4.046,13.7,13.7,0,0,1-.162,2.156,4.475,4.475,0,0,1-.753,2.121,1.878,1.878,0,0,1-1.7.684,2.805,2.805,0,0,1-1.623-.8,6.375,6.375,0,0,1-1.368-3.072h.267a10.2,10.2,0,0,1-1.356,2.678,3.7,3.7,0,0,1-2.318,1.449,2.423,2.423,0,0,1-1.287-.151,2.116,2.116,0,0,1-1.24-1.889,1.577,1.577,0,0,1,.336-.974l.139.1a7.94,7.94,0,0,1-2.539,2.145,5.694,5.694,0,0,1-.8.359l-.29.093.267-.128c.185-.093.452-.22.777-.406a8.114,8.114,0,0,0,2.446-2.168l.139.1a1.588,1.588,0,0,0,0,1.843,1.82,1.82,0,0,0,.823.707,2.2,2.2,0,0,0,1.159.128,3.477,3.477,0,0,0,2.156-1.368,10.05,10.05,0,0,0,1.3-2.62l.162-.406.1.417a6.167,6.167,0,0,0,1.31,2.944,2.423,2.423,0,0,0,1.449.707,1.565,1.565,0,0,0,1.449-.58,4.324,4.324,0,0,0,.7-1.982,14.468,14.468,0,0,0,.151-2.11,31.643,31.643,0,0,0-.3-4.011c-.151-1.287-.3-2.5-.359-3.651a16.506,16.506,0,0,1,.174-3.2,8.636,8.636,0,0,1,1.785-4.254A5.17,5.17,0,0,1,148.537,164.43Z",
    transform: "translate(-56.347 -152.778)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5822",
    "data-name": "Path 5822",
    d: "M185.064,175.279l-.093.093-.29.243a4.632,4.632,0,0,1-.51.359,5.8,5.8,0,0,1-.73.441,10.815,10.815,0,0,1-5.228,1.252,14.05,14.05,0,0,1-7.616-2.318,24.343,24.343,0,0,1-6.828-7.013c-.985-1.437-1.8-2.933-2.689-4.3a16.1,16.1,0,0,0-2.979-3.605,8.311,8.311,0,0,0-3.675-1.959,5.8,5.8,0,0,0-1.889-.1,6.549,6.549,0,0,0-1.7.417,7.326,7.326,0,0,0-2.481,1.7,6.955,6.955,0,0,0-1.3,1.889,8.7,8.7,0,0,0-.533,1.889,1.267,1.267,0,0,1,0-.139,2.584,2.584,0,0,1,0-.371,5.865,5.865,0,0,1,.383-1.426,7.152,7.152,0,0,1,3.8-3.733,7.026,7.026,0,0,1,1.762-.464,6.248,6.248,0,0,1,1.959.1,8.543,8.543,0,0,1,3.8,1.982,16.518,16.518,0,0,1,3.049,3.651c.893,1.379,1.716,2.875,2.689,4.3a24.169,24.169,0,0,0,6.735,6.955,13.91,13.91,0,0,0,7.465,2.318,11.314,11.314,0,0,0,5.182-1.159,18.781,18.781,0,0,0,1.716-1.009Z",
    transform: "translate(-53.971 -153.785)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5823",
    "data-name": "Path 5823",
    d: "M173.731,185.011c-.232.267-1.727-.8-3.791-.742s-3.559,1.159-3.791.916.1-.591.753-1.1a5.147,5.147,0,0,1,3.025-1.043,5.008,5.008,0,0,1,3.037.9C173.615,184.431,173.847,184.9,173.731,185.011Z",
    transform: "translate(-50.857 -149.816)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5824",
    "data-name": "Path 5824",
    d: "M172.1,189.041a1.681,1.681,0,0,1-1.646,1.669,1.6,1.6,0,0,1-1.7-1.542,1.669,1.669,0,0,1,1.634-1.658,1.6,1.6,0,0,1,1.716,1.53Z",
    transform: "translate(-50.432 -149.105)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5825",
    "data-name": "Path 5825",
    d: "M175.441,164.82c1.159,1.333,2.782,2.527,4.509,2.318a13.318,13.318,0,0,0,1.82-.626c.614.336.568,2.423.174,3.014a10.688,10.688,0,0,1-1.24,1.391c2.087,1.008,3.918.383,6.039-.5a10.63,10.63,0,0,1-5.923,8.8,3.756,3.756,0,0,1-3.408.22,4.324,4.324,0,0,1-1.623-2.6,46.76,46.76,0,0,1-2.029-11.3Z",
    transform: "translate(-49.634 -152.716)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5826",
    "data-name": "Path 5826",
    d: "M190.214,302.232s-2.26-13.783-4.637-18.872a24.945,24.945,0,0,1-2.492-9.436s2.087-11.592.591-18.419-5.216-22.708-11.093-29.351L142.5,217.82s-15.869,8.172-17.307,9.923S113.72,238.43,113.87,250.984c.093,7.836,11.488,35.877,11.488,35.877l9.181,63.407,19.057,2.689,46.75-4.637-2.214-14.154C194.4,320.037,190.214,302.232,190.214,302.232Z",
    transform: "translate(-59.168 -144.279)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5827",
    "data-name": "Path 5827",
    d: "M181.926,300.384a3.476,3.476,0,0,0-.081-.742c-.07-.487-.185-1.159-.348-2.11-.325-1.831-.835-4.463-1.658-7.685a89.388,89.388,0,0,0-3.628-11.07,14.548,14.548,0,0,1-1.043-6.619c.093-2.318.5-4.8.626-7.338a67.453,67.453,0,0,0-3.872-25.572,62.432,62.432,0,0,0-3.107-7.268c-.417-.846-.788-1.472-1.02-1.9a3.764,3.764,0,0,0-.406-.649,3.815,3.815,0,0,0,.29.7c.2.452.533,1.09.9,1.947a73.186,73.186,0,0,1,2.875,7.291,69.806,69.806,0,0,1,3.675,25.4c-.128,2.5-.533,4.95-.614,7.349a14.942,14.942,0,0,0,1.159,6.839,97.375,97.375,0,0,1,3.779,11.035c.869,3.188,1.437,5.8,1.843,7.627.2.858.348,1.542.464,2.087A3.3,3.3,0,0,0,181.926,300.384Z",
    transform: "translate(-50.648 -142.431)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5828",
    "data-name": "Path 5828",
    d: "M268.81,333.17l22.048,96.815-18.57,4.15Z",
    transform: "translate(-34.504 -125.917)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5829",
    "data-name": "Path 5829",
    d: "M292.7,342.057c-3.686-20.112-16.287-25.5-25.572-26.267-10.433-.869-138.615-1.6-138.615-1.6L127.81,324.3l79.369,36.8,50.1-.348,12.531,82.059,29.9-4.08S296.379,362.169,292.7,342.057Z",
    transform: "translate(-56.949 -128.938)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5830",
    "data-name": "Path 5830",
    d: "M270.642,340c.162,0,1.716,21.167,3.478,47.295s3.025,47.318,2.863,47.33-1.727-21.155-3.478-47.295S270.48,340,270.642,340Z",
    transform: "translate(-34.214 -124.83)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5831",
    "data-name": "Path 5831",
    d: "M127.572,259.448,143,333l-42.89-2.237-1.623-63.373-27.716-.313A4.127,4.127,0,0,1,66.68,262.9h0a4.15,4.15,0,0,1,4.185-4.092Z",
    transform: "translate(-66.68 -137.754)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5832",
    "data-name": "Path 5832",
    d: "M95.55,322.023l1.333,49.984,130.988.406A12.751,12.751,0,0,0,240.7,359.766h0a12.751,12.751,0,0,0-12.38-12.925L217,346.47l.614-24.876a6.515,6.515,0,0,0-6.445-6.677L103.711,313.7a8.114,8.114,0,0,0-8.161,8.323Z",
    transform: "translate(-62.084 -129.016)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18142",
    "data-name": "Rectangle 18142",
    width: 7.662,
    height: 77.109,
    transform: "matrix(1, 0.011, -0.011, 1, 82.185, 227.15)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18143",
    "data-name": "Rectangle 18143",
    width: 108.801,
    height: 6.433,
    transform: "matrix(1, 0.011, -0.011, 1, 81.381, 297.504)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5833",
    "data-name": "Path 5833",
    d: "M154.749,474.6a71.423,71.423,0,1,1,.846,0ZM105.472,350.565a71.661,71.661,0,1,0,50.911-20.425h-.835a71.151,71.151,0,0,0-50.112,20.4Z",
    transform: "translate(-63.962 -126.399)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5834",
    "data-name": "Path 5834",
    d: "M182.055,392.9c-19.868-.232-35.935-.44-35.935-.452s16.113.162,35.935.406,35.935.44,35.935.452S201.923,393.146,182.055,392.9Z",
    transform: "translate(-54.034 -116.481)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5835",
    "data-name": "Path 5835",
    d: "M181.518,398.863c-19.579-3.478-35.448-6.26-35.448-6.283s15.869,2.782,35.448,6.236,35.436,6.271,35.436,6.283S201.073,402.34,181.518,398.863Z",
    transform: "translate(-54.042 -116.46)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5836",
    "data-name": "Path 5836",
    d: "M180,404.649c-18.744-6.619-33.929-12-33.929-12.009s15.2,5.344,33.941,11.963l33.918,12.021S198.72,411.222,180,404.649Z",
    transform: "translate(-54.042 -116.45)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5837",
    "data-name": "Path 5837",
    d: "M177.555,410.038c-17.388-9.61-31.507-17.388-31.5-17.388l31.518,17.388c17.388,9.61,31.483,17.388,31.483,17.388S194.943,419.647,177.555,410.038Z",
    transform: "translate(-54.044 -116.449)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5838",
    "data-name": "Path 5838",
    d: "M174.261,415.006C158.658,402.684,146,392.692,146,392.68s12.658,9.969,28.261,22.279,28.238,22.3,28.226,22.314S189.852,427.316,174.261,415.006Z",
    transform: "translate(-54.053 -116.444)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5839",
    "data-name": "Path 5839",
    d: "M170.192,419.352C156.792,404.63,146,392.76,146,392.76s10.873,11.882,24.273,26.569,24.25,26.58,24.239,26.592S183.581,434.027,170.192,419.352Z",
    transform: "translate(-54.053 -116.431)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5840",
    "data-name": "Path 5840",
    d: "M165.492,422.989c-10.838-16.669-19.613-30.139-19.6-30.139s8.8,13.493,19.706,30.139,19.6,30.139,19.59,30.139S176.33,439.646,165.492,422.989Z",
    transform: "translate(-54.071 -116.417)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5841",
    "data-name": "Path 5841",
    d: "M160.249,425.819c-7.964-18.211-14.42-32.967-14.409-32.979s6.48,14.756,14.455,32.967,14.42,32.956,14.409,32.967S168.224,444.03,160.249,425.819Z",
    transform: "translate(-54.079 -116.419)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5842",
    "data-name": "Path 5842",
    d: "M154.62,427.791c-4.88-19.266-8.821-34.891-8.81-34.891s3.976,15.614,8.856,34.88,8.81,34.891,8.8,34.891S159.488,447.011,154.62,427.791Z",
    transform: "translate(-54.083 -116.409)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5843",
    "data-name": "Path 5843",
    d: "M148.739,428.735c-1.658-19.81-2.991-35.865-2.979-35.865s1.368,16.055,3.025,35.865,2.991,35.854,2.979,35.854S150.4,448.534,148.739,428.735Z",
    transform: "translate(-54.091 -116.414)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5844",
    "data-name": "Path 5844",
    d: "M143.564,428.747c1.553-19.822,2.828-35.877,2.84-35.877s-1.229,16.066-2.794,35.935-2.817,35.865-2.84,35.865S142.01,448.557,143.564,428.747Z",
    transform: "translate(-54.886 -116.414)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5845",
    "data-name": "Path 5845",
    d: "M139.283,427.8c4.764-19.3,8.648-34.938,8.659-34.938s-3.848,15.649-8.613,34.949-8.648,34.926-8.659,34.926S134.53,447.087,139.283,427.8Z",
    transform: "translate(-56.493 -116.415)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5846",
    "data-name": "Path 5846",
    d: "M135.176,425.9c7.871-18.257,14.27-33.048,14.281-33.037s-6.364,14.8-14.246,33.048-14.27,33.037-14.281,33.025S127.294,444.131,135.176,425.9Z",
    transform: "translate(-58.044 -116.415)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5847",
    "data-name": "Path 5847",
    d: "M131.341,423.095c10.757-16.727,19.486-30.266,19.5-30.255s-8.682,13.562-19.451,30.324-19.486,30.243-19.5,30.243S120.6,439.8,131.341,423.095Z",
    transform: "translate(-59.483 -116.419)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5848",
    "data-name": "Path 5848",
    d: "M127.9,419.471c13.331-14.756,24.146-26.661,24.146-26.661s-10.78,11.963-24.111,26.661S103.8,446.132,103.79,446.132,114.57,434.2,127.9,419.471Z",
    transform: "translate(-60.772 -116.423)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5849",
    "data-name": "Path 5849",
    d: "M124.922,415.139c15.545-12.392,28.157-22.43,28.168-22.419s-12.589,10.062-28.133,22.453S96.812,437.592,96.8,437.58,109.389,427.519,124.922,415.139Z",
    transform: "translate(-61.885 -116.438)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5850",
    "data-name": "Path 5850",
    d: "M122.512,410.2c17.388-9.7,31.414-17.55,31.425-17.538s-14.049,7.882-31.4,17.573-31.414,17.6-31.425,17.6S105.159,419.889,122.512,410.2Z",
    transform: "translate(-62.791 -116.447)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5851",
    "data-name": "Path 5851",
    d: "M120.708,404.768c18.709-6.723,33.871-12.16,33.883-12.148s-15.151,5.471-33.86,12.195S86.86,416.986,86.86,416.963,102.011,411.492,120.708,404.768Z",
    transform: "translate(-63.467 -116.454)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5852",
    "data-name": "Path 5852",
    d: "M119.592,399.023c19.555-3.57,35.413-6.445,35.413-6.433s-15.846,2.91-35.413,6.48-35.39,6.433-35.4,6.422S100.048,402.571,119.592,399.023Z",
    transform: "translate(-63.892 -116.458)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5853",
    "data-name": "Path 5853",
    d: "M119.155,393.08c19.88-.336,35.993-.591,35.993-.58l-35.993.626c-19.857.336-35.935.6-35.935.58Z",
    transform: "translate(-64.047 -116.473)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5854",
    "data-name": "Path 5854",
    d: "M119.439,388.582c19.706,2.875,35.61,5.228,35.61,5.24s-15.939-2.318-35.61-5.193-35.61-5.216-35.6-5.228S99.779,385.707,119.439,388.582Z",
    transform: "translate(-63.948 -117.921)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5855",
    "data-name": "Path 5855",
    d: "M120.415,384.354c18.941,6.074,34.277,11,34.266,11.012S139.333,390.475,120.4,384.4s-34.265-10.989-34.254-11S101.5,378.292,120.415,384.354Z",
    transform: "translate(-63.58 -119.513)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5856",
    "data-name": "Path 5856",
    d: "M122.075,380.357c17.689,9.088,32.005,16.472,31.993,16.484s-14.328-7.349-32.017-16.449S90.07,363.932,90.07,363.92,104.409,371.269,122.075,380.357Z",
    transform: "translate(-62.956 -121.022)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5857",
    "data-name": "Path 5857",
    d: "M124.378,376.673c15.95,11.847,28.875,21.468,28.875,21.48s-12.948-9.586-28.91-21.445S95.468,355.24,95.48,355.24,108.428,364.826,124.378,376.673Z",
    transform: "translate(-62.095 -122.404)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5858",
    "data-name": "Path 5858",
    d: "M127.238,373.408c13.829,14.293,25.015,25.873,25.015,25.885s-11.221-11.592-25.05-25.85-25.015-25.861-25-25.873S113.421,359.139,127.238,373.408Z",
    transform: "translate(-61.025 -123.625)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5859",
    "data-name": "Path 5859",
    d: "M130.6,370.659c11.325,16.333,20.483,29.582,20.483,29.594s-9.2-13.226-20.529-29.571S110.068,341.1,110.08,341.1,119.261,354.326,130.6,370.659Z",
    transform: "translate(-59.771 -124.655)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5860",
    "data-name": "Path 5860",
    d: "M134.347,368.457C142.856,386.424,149.741,401,149.73,401s-6.955-14.548-15.429-32.457S118.918,336,118.93,336,125.839,350.525,134.347,368.457Z",
    transform: "translate(-58.362 -125.467)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5861",
    "data-name": "Path 5861",
    d: "M138.356,366.962c5.448,19.115,9.853,34.613,9.841,34.625s-4.44-15.487-9.888-34.613-9.841-34.613-9.83-34.613S132.966,347.858,138.356,366.962Z",
    transform: "translate(-56.842 -126.046)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5862",
    "data-name": "Path 5862",
    d: "M142.649,366.119c2.237,19.706,4.046,35.761,4.034,35.772s-1.843-16.008-4.08-35.761-4.034-35.761-4.022-35.761S140.423,346.378,142.649,366.119Z",
    transform: "translate(-55.234 -126.363)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5863",
    "data-name": "Path 5863",
    d: "M147.487,365.985c-.974,19.857-1.785,35.935-1.8,35.935s.765-16.09,1.75-35.935,1.774-35.935,1.785-35.935S148.46,346.139,147.487,365.985Z",
    transform: "translate(-54.103 -126.414)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5864",
    "data-name": "Path 5864",
    d: "M153.4,366.55c-4.2,19.428-7.616,35.181-7.627,35.181s3.373-15.753,7.581-35.193,7.6-35.17,7.616-35.158S157.628,347.168,153.4,366.55Z",
    transform: "translate(-54.09 -126.202)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5865",
    "data-name": "Path 5865",
    d: "M159.107,367.814c-7.338,18.477-13.3,33.442-13.307,33.442s5.923-14.988,13.261-33.466,13.284-33.431,13.3-33.431S166.433,349.348,159.107,367.814Z",
    transform: "translate(-54.085 -125.728)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5866",
    "data-name": "Path 5866",
    d: "M164.437,369.744c-10.27,17.028-18.547,30.811-18.547,30.811s8.3-13.817,18.547-30.846,18.547-30.8,18.547-30.8S174.684,352.727,164.437,369.744Z",
    transform: "translate(-54.071 -125.003)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5867",
    "data-name": "Path 5867",
    d: "M169.268,372.272c-12.89,15.139-23.346,27.392-23.358,27.38s10.433-12.276,23.323-27.4,23.346-27.38,23.358-27.368S182.158,357.156,169.268,372.272Z",
    transform: "translate(-54.068 -124.053)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5868",
    "data-name": "Path 5868",
    d: "M173.476,375.355c-15.185,12.844-27.484,23.184-27.5,23.184s12.287-10.433,27.461-23.265,27.473-23.184,27.484-23.184S188.638,362.523,173.476,375.355Z",
    transform: "translate(-54.056 -122.905)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5869",
    "data-name": "Path 5869",
    d: "M176.939,378.879C159.91,389.091,146,397.345,146,397.333s13.817-8.288,30.881-18.489,30.881-18.466,30.892-18.454S193.99,368.69,176.939,378.879Z",
    transform: "translate(-54.053 -121.584)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5870",
    "data-name": "Path 5870",
    d: "M179.6,382.811c-18.547,7.28-33.5,13.168-33.512,13.145l33.489-13.192c18.489-7.268,33.489-13.157,33.5-13.145S198.045,375.5,179.6,382.811Z",
    transform: "translate(-54.039 -120.115)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5871",
    "data-name": "Path 5871",
    d: "M181.274,386.922c-19.451,4.138-35.2,7.477-35.2,7.465s15.753-3.373,35.193-7.512,35.193-7.477,35.193-7.465S200.7,382.783,181.274,386.922Z",
    transform: "translate(-54.042 -118.556)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5872",
    "data-name": "Path 5872",
    d: "M182.025,391.231c-19.857.9-35.935,1.634-35.935,1.623s16.089-.765,35.935-1.681l35.935-1.623S201.87,390.315,182.025,391.231Z",
    transform: "translate(-54.039 -116.942)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5873",
    "data-name": "Path 5873",
    d: "M152.172,393.252a5.286,5.286,0,1,1-5.216-5.332,5.286,5.286,0,0,1,5.216,5.332Z",
    transform: "translate(-54.754 -117.202)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5874",
    "data-name": "Path 5874",
    d: "M230.976,429.33a20.552,20.552,0,1,0,14.477,6.183,20.564,20.564,0,0,0-14.477-6.183Zm-.406,36.526a15.962,15.962,0,1,1,16.136-15.788,15.962,15.962,0,0,1-16.136,15.788Z",
    transform: "translate(-43.837 -110.61)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5875",
    "data-name": "Path 5875",
    d: "M233.278,461.129l-4.938-.058,1.24-109.636-17.33-.2.046-4.938,22.28.255Z",
    transform: "translate(-43.507 -123.827)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5876",
    "data-name": "Path 5876",
    d: "M253.681,456.275c0-.545.6-79.763.3-94.763a8.705,8.705,0,0,0-3.57-7.233c-6.723-5.077-20.529-3.478-20.668-3.478l-.684-4.3c.649-.081,16.124-1.878,24.552,4.463a12.832,12.832,0,0,1,5.309,10.433c.3,15.069-.3,94.323-.3,94.868Z",
    transform: "translate(-40.831 -123.842)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18144",
    "data-name": "Rectangle 18144",
    width: 39.563,
    height: 4.822,
    transform: "matrix(1, 0.011, -0.011, 1, 212.286, 329.033)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5877",
    "data-name": "Path 5877",
    d: "M158.47,320.941a83.38,83.38,0,1,0,82.43,84.331A83.38,83.38,0,0,0,158.47,320.941Zm-1.843,162.471c-42.8-.487-77.086-36.282-76.587-79.984s35.587-78.7,78.372-78.21,77.1,36.282,76.6,79.984S199.424,483.887,156.627,483.412Z",
    transform: "translate(-65.491 -127.865)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5878",
    "data-name": "Path 5878",
    d: "M142.915,300.412c-1.159-1.345-.128-44.942-.533-43.469-1.159,4.254-26.3-5.993-26.3-5.993h0s2.515,55.293,4.011,60.614c1.9,6.735,48.419,34.59,48.419,34.59l10.062-9.668Z",
    transform: "translate(-58.816 -139.005)",
    fill: "#ac815f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5879",
    "data-name": "Path 5879",
    d: "M138.316,225.952a7.662,7.662,0,0,0-10.2.545c-5.124,5.124-14.455,12.809-14.675,19.8-.348,10.676-.174,39.841-.174,39.841l39.273-1.379s0-37.558-3.478-46.17C147.149,233.718,142.222,229.07,138.316,225.952Z",
    transform: "translate(-59.271 -143.253)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5880",
    "data-name": "Path 5880",
    d: "M112.67,285.169a2.387,2.387,0,0,1,.661-.093l1.9-.116,7.106-.336,24.343-.939-.336.336c.093-3.408,0-7.048-.162-10.792-.3-6.178-.846-12.056-1.159-17.388-.185-2.689-.255-5.24-.475-7.6a44.487,44.487,0,0,0-1.008-6.515,24.76,24.76,0,0,0-3.8-8.682c-1.321-1.832-2.318-2.643-2.26-2.7a3.478,3.478,0,0,1,.719.58,15.476,15.476,0,0,1,1.762,1.947,23.949,23.949,0,0,1,4.08,8.729,44.968,44.968,0,0,1,1.159,6.584c.243,2.388.336,4.938.545,7.616.383,5.355.939,11.233,1.252,17.388.185,3.756.243,7.419.139,10.85v.394h-.464l-24.343.672-7.117.139H113.3A3.282,3.282,0,0,1,112.67,285.169Z",
    transform: "translate(-59.359 -142.286)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5881",
    "data-name": "Path 5881",
    d: "M198.716,340.183l-4.2-10.433-9.529-6.039-19.451-.661-5.46,10.433s4.915,4.474,7.616,5.2,8.555,2.62,8.555,2.62l6.236,2.237,1.785,2.481,1.043,3.234a1.669,1.669,0,0,0,2.376-1.252,13.98,13.98,0,0,0-.73-5.367l-2.967-3.617,3.814,2.005,2.005,6.538s2.226.661,2.539-1.24l.313-1.889s1.75.58,2.2-1.588a22.638,22.638,0,0,0,.452-4.115A2.991,2.991,0,0,0,198.716,340.183Z",
    transform: "translate(-51.812 -127.528)",
    fill: "#ac815f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5882",
    "data-name": "Path 5882",
    d: "M182,331.24a8.81,8.81,0,0,1,1.982,1.09l2.063,1.333,1.159.8a4.069,4.069,0,0,1,1.159,1.159,7.221,7.221,0,0,1,.626,3.025c0,.858.116,1.669.162,2.446a8.347,8.347,0,0,1,0,2.26,8.462,8.462,0,0,1-.429-2.226c-.093-.765-.185-1.576-.29-2.423a7.338,7.338,0,0,0-.591-2.782,8.115,8.115,0,0,0-2.179-1.831l-1.982-1.426A8.8,8.8,0,0,1,182,331.24Z",
    transform: "translate(-48.323 -126.224)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5883",
    "data-name": "Path 5883",
    d: "M184.37,328.3a5.623,5.623,0,0,1,1.681.962,28.365,28.365,0,0,1,3.675,2.886,7.094,7.094,0,0,1,1.855,4.324,4.347,4.347,0,0,1-.058,1.947,10.748,10.748,0,0,1-.359-1.878,7.685,7.685,0,0,0-1.866-3.976c-1.275-1.217-2.6-2.214-3.478-2.968A9.3,9.3,0,0,1,184.37,328.3Z",
    transform: "translate(-47.946 -126.692)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10681",
    "data-name": "Group 10681",
    transform: "translate(83.392 109.012)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5884",
    "data-name": "Path 5884",
    d: "M141.24,248.42l5.1,35.17-5.518.9.985,14.455,21.1,25.711-23.578-23.844-.707-19.2,3.941-.811Z",
    transform: "translate(-138.62 -248.42)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-56",
    transform: "translate(657.72 281.867)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18145",
    "data-name": "Rectangle 18145",
    width: 114.388,
    height: 159.214,
    transform: "translate(0 90.556)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5885",
    "data-name": "Path 5885",
    d: "M647.791,486.173c-.162,0-.3-35.726-.3-79.775s.139-79.8.3-79.8.3,35.714.3,79.8S647.954,486.173,647.791,486.173Z",
    transform: "translate(-562.557 -236.415)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18146",
    "data-name": "Rectangle 18146",
    width: 81.908,
    height: 79.532,
    transform: "translate(16.437 9.482)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5886",
    "data-name": "Path 5886",
    d: "M670.325,336.583v-5.819c0-3.744,0-9.216-.07-16.171,0-13.91-.081-33.767-.128-57.588l.255.255h-81.9l.3-.3v79.532l-.267-.267,59.281.127,16.681.07h.127l-16.623.07-59.443.128h-.255V256.53h82.476v.545c0,23.891-.1,43.806-.139,57.751,0,6.955,0,12.38-.07,16.113v5.309A.363.363,0,0,1,670.325,336.583Z",
    transform: "translate(-571.98 -247.569)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18147",
    "data-name": "Rectangle 18147",
    width: 30.904,
    height: 46.414,
    transform: "matrix(0.884, -0.468, 0.468, 0.884, 26.018, 23.959)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5887",
    "data-name": "Path 5887",
    d: "M624.02,257.008l-.5.3-1.437.788-5.483,2.968-19.787,10.607.1-.325,21.758,41-.406-.128h.058l.1-.058.232-.116.452-.243.916-.475,1.8-.962,3.582-1.889,6.955-3.686,13.157-6.955-.116.371L630,268.6l-4.417-8.508c-.5-.974-.881-1.727-1.159-2.318-.116-.255-.209-.44-.29-.6l-.1-.22s0,.058.116.174l.313.556c.29.533.684,1.263,1.159,2.2,1.066,1.971,2.585,4.811,4.509,8.369l15.811,29.606.128.243-.244.128-13.134,6.955-6.955,3.7-3.57,1.889-1.808.962-.9.475-.464.243-.22.116-.116.07H618.6l-.417-.128-21.654-41.047-.1-.22.209-.1,20.031-10.433,5.495-2.84,1.426-.719Z",
    transform: "translate(-570.686 -247.503)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5888",
    "data-name": "Path 5888",
    d: "M617,284.974l5.981-.464.591,1.159-3.756,4.637-.649-1.217,2.7-3.327-4.277.336Z",
    transform: "translate(-567.41 -243.116)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5889",
    "data-name": "Path 5889",
    d: "M620.214,284.34a2.318,2.318,0,1,1,.835-3.083,2.179,2.179,0,0,1-.835,3.083Zm-1.588-3.014a1.055,1.055,0,0,0-.533,1.5,1.159,1.159,0,1,0,.533-1.5Z",
    transform: "translate(-567.459 -243.827)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5890",
    "data-name": "Path 5890",
    d: "M618.4,276.72a1.75,1.75,0,0,1,.707.765,1.4,1.4,0,0,1-.6,2.11l-1.542.811.313.58-.835.441-.313-.58-.9.487-.58-1.09.916-.487-.5-.927.835-.44.5.927,1.519-.8a.5.5,0,0,0,.255-.73.846.846,0,0,0-.371-.359Z",
    transform: "translate(-567.786 -244.356)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5891",
    "data-name": "Path 5891",
    d: "M615.008,273.831l1.5,2.828a1.159,1.159,0,0,0,.185-1.472,1.414,1.414,0,0,0-.858-.742l.325-.916a2.481,2.481,0,0,1,.626,4.382,2.168,2.168,0,0,1-2.991-.974,2.1,2.1,0,0,1,.916-2.979A2.32,2.32,0,0,1,615.008,273.831Zm.869,3.176-.974-1.843a1.055,1.055,0,0,0,.974,1.843Z",
    transform: "translate(-567.968 -244.863)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18148",
    "data-name": "Rectangle 18148",
    width: 30.904,
    height: 46.414,
    transform: "translate(21.737 61.577) rotate(-78.09)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5892",
    "data-name": "Path 5892",
    d: "M638.389,315.649a3.821,3.821,0,0,1,.093-.58c.07-.394.174-.927.313-1.611l1.159-6.109c1.09-5.286,2.631-12.821,4.509-22.025l.185.278-45.428-9.517.359-.232h0v.58l-.1.51-.22,1-.417,2.005c-.278,1.333-.556,2.643-.835,3.953-.556,2.62-1.159,5.2-1.634,7.732-1.078,5.054-2.11,9.923-3.083,14.548l-.22-.336,32.631,7.025,9.355,2.04,2.5.568.649.151.232.07h-.209l-.626-.1-2.457-.487-9.273-1.889-32.863-6.793-.267-.058.058-.267c.962-4.637,1.994-9.494,3.049-14.548q.8-3.814,1.623-7.732.417-1.959.835-3.964l.417-1.994.22-1.008.1-.5v-.5h0c-.325.2.44-.29.359-.243l45.405,9.633h.232v.232c-1.994,9.216-3.64,16.785-4.787,22.025-.568,2.585-1.02,4.637-1.333,6.039-.151.661-.267,1.159-.359,1.553A2.5,2.5,0,0,1,638.389,315.649Z",
    transform: "translate(-571.272 -244.533)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5893",
    "data-name": "Path 5893",
    d: "M613.5,290.052l-3.478,4.892-1.229-.255L607.63,288.8l1.345.29.823,4.2,2.481-3.478Z",
    transform: "translate(-568.902 -242.433)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5894",
    "data-name": "Path 5894",
    d: "M611.866,292.961a2.318,2.318,0,1,1,1.832,2.62,2.191,2.191,0,0,1-1.832-2.62Zm3.338.707a1.066,1.066,0,0,0-.811-1.368,1.159,1.159,0,1,0,.811,1.368Z",
    transform: "translate(-568.235 -242.084)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5895",
    "data-name": "Path 5895",
    d: "M618.79,296.5a1.7,1.7,0,0,1-1.032.058,1.4,1.4,0,0,1-1.24-1.808l.371-1.7-.649-.139.2-.916.638.127.22-1.008,1.159.255-.209,1.008,1.032.22-.2.927-1.032-.22-.359,1.692a.5.5,0,0,0,.406.649.892.892,0,0,0,.522,0Z",
    transform: "translate(-567.531 -242.065)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5896",
    "data-name": "Path 5896",
    d: "M623.252,295.689l-3.13-.661a1.159,1.159,0,0,0,1.008,1.078,1.437,1.437,0,0,0,1.159-.185l.487.835a2.469,2.469,0,0,1-3.756-2.318,2.144,2.144,0,0,1,2.654-1.658,2.087,2.087,0,0,1,1.7,2.6A1.269,1.269,0,0,0,623.252,295.689Zm-3-1.368,2.04.429a1.055,1.055,0,0,0-2.04-.429Z",
    transform: "translate(-567.09 -241.811)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18149",
    "data-name": "Rectangle 18149",
    width: 30.904,
    height: 46.414,
    transform: "translate(18.155 41.249) rotate(-7.11)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5897",
    "data-name": "Path 5897",
    d: "M620.591,281.1l-.568.093-1.634.232-6.178.835-22.256,2.9.209-.267c1.6,12.693,3.617,28.7,5.8,46.054l-.336-.267h.5l.522-.07,1.008-.128,2.029-.243,4.022-.51,7.836-.962,14.756-1.831-.243.313c-1.634-13.516-3.014-24.992-4-33.129-.464-4.057-.846-7.268-1.159-9.517-.116-1.078-.209-1.936-.278-2.55l-.07-.661v-.035l.093.626c.081.6.2,1.426.348,2.492.29,2.226.719,5.413,1.24,9.424l4.289,33.28v.278h-.267l-14.756,1.855-7.836.985-4.011.5-2.029.255-1.02.128-.51.058h-.51l-.336-.267c-2.144-17.388-4.115-33.373-5.68-46.066v-.243h.243l22.43-2.666,6.144-.707,1.588-.174Z",
    transform: "translate(-571.778 -243.658)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5898",
    "data-name": "Path 5898",
    d: "M603.45,306.1l5.8,1.681.151,1.252-5.17,3.037-.174-1.368,3.7-2.145-4.115-1.159Z",
    transform: "translate(-569.567 -239.679)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5899",
    "data-name": "Path 5899",
    d: "M606.756,306.631a2.318,2.318,0,1,1,1.878-2.585,2.168,2.168,0,0,1-1.878,2.585Zm-.44-3.478a1.09,1.09,0,1,0,1.071.388A1.09,1.09,0,0,0,606.316,303.154Z",
    transform: "translate(-569.477 -240.326)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5900",
    "data-name": "Path 5900",
    d: "M607.793,298.74a1.774,1.774,0,0,1,.394.962,1.391,1.391,0,0,1-1.31,1.75l-1.727.22.081.649-.939.116-.081-.649-1.02.128-.151-1.217,1.02-.128-.128-1.043.927-.116.139,1.043,1.7-.22a.487.487,0,0,0,.487-.591.741.741,0,0,0-.209-.464Z",
    transform: "translate(-569.632 -240.85)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5901",
    "data-name": "Path 5901",
    d: "M605.612,294.9l.394,3.176a1.159,1.159,0,0,0,.7-1.31,1.426,1.426,0,0,0-.533-1l.626-.742a2.237,2.237,0,0,1,.893,1.658,2.2,2.2,0,0,1-1.866,2.666,2.168,2.168,0,0,1-2.446-1.971,2.11,2.11,0,0,1,1.913-2.469Zm-.313,3.28-.255-2.063a1.055,1.055,0,0,0,.255,2.063Z",
    transform: "translate(-569.584 -241.462)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18150",
    "data-name": "Rectangle 18150",
    width: 46.414,
    height: 30.904,
    transform: "matrix(0.125, -0.992, 0.992, 0.125, 58.174, 66.582)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5902",
    "data-name": "Path 5902",
    d: "M660.944,270.406a5.03,5.03,0,0,1-.58,0l-1.646-.174-6.19-.719-22.279-2.678.267-.209c-1.588,12.693-3.582,28.7-5.8,46.054l-.267-.336h.51l.51.07,1.02.127,2.029.255,4.011.51,7.836,1,14.745,1.866-.313.243c1.762-13.493,3.257-24.957,4.312-33.095.545-4.034.974-7.245,1.275-9.494q.22-1.623.348-2.539l.1-.661a.951.951,0,0,1,0-.232v.209a2.427,2.427,0,0,1-.07.638c0,.591-.162,1.426-.278,2.481-.267,2.237-.638,5.437-1.159,9.459-1,8.184-2.4,19.706-4.057,33.3v.278H655l-14.756-1.843-7.836-.985-4.011-.5-2.029-.255-1.02-.128-.51-.07h-.5l-.267-.348c2.2-17.388,4.243-33.35,5.865-46.043v-.232h.243l22.407,2.956,6.121.835,1.588.22Z",
    transform: "translate(-566.285 -246.005)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5903",
    "data-name": "Path 5903",
    d: "M637.337,290.92l5.17,3.049-.151,1.252-5.8,1.669.174-1.368,4.115-1.159-3.663-2.191Z",
    transform: "translate(-564.296 -242.095)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5904",
    "data-name": "Path 5904",
    d: "M640.407,292.146a2.318,2.318,0,1,1,2.458-2.04,2.191,2.191,0,0,1-2.458,2.04Zm.429-3.385a1.09,1.09,0,1,0,1.02,1.217,1.066,1.066,0,0,0-1.02-1.217Z",
    transform: "translate(-564.028 -242.637)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5905",
    "data-name": "Path 5905",
    d: "M643.351,284.727a1.727,1.727,0,0,1,.139,1.02,1.4,1.4,0,0,1-1.7,1.391l-1.727-.22-.081.649-.939-.116.081-.649-1.02-.139.151-1.217,1.032.128.128-1.043.939.116-.139,1.055,1.716.209a.487.487,0,0,0,.614-.452.776.776,0,0,0-.093-.51Z",
    transform: "translate(-564.051 -243.112)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5906",
    "data-name": "Path 5906",
    d: "M642.175,280.532l-.394,3.188a1.159,1.159,0,0,0,1-1.1,1.449,1.449,0,0,0-.278-1.1l.788-.556a2.469,2.469,0,0,1-2.005,3.941,2.156,2.156,0,0,1-1.878-2.515,2.087,2.087,0,0,1,2.446-1.913Zm-1.159,3.107.266-2.063a1.055,1.055,0,0,0-.266,2.063Z",
    transform: "translate(-563.849 -243.763)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18151",
    "data-name": "Rectangle 18151",
    width: 46.414,
    height: 30.904,
    transform: "translate(44.605 56.418)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5907",
    "data-name": "Path 5907",
    d: "M659.165,328.413v-2.226c0-1.472,0-3.57-.07-6.236,0-5.39-.07-13.076-.128-22.442l.243.243-46.367.058c-.07,0,.568-.568.3-.3h0V328.39l-.278-.278,33.373.139,9.575.07h-.023l-9.517.07-33.547.139h-.278v-31h0c-.278.267.359-.371.3-.3l46.367.058h.348v.243c-.058,9.424-.093,17.168-.128,22.592,0,2.643,0,4.729-.058,6.178v1.6a2.511,2.511,0,0,1-.116.51Z",
    transform: "translate(-568.146 -241.091)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5908",
    "data-name": "Path 5908",
    d: "M630.368,308.263l-2.388,5.495h-1.252l-2.318-5.518h1.368l1.681,3.941,1.7-3.941Z",
    transform: "translate(-566.23 -239.338)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5909",
    "data-name": "Path 5909",
    d: "M629.321,311.527a2.318,2.318,0,1,1,2.318,2.179,2.179,2.179,0,0,1-2.318-2.179Zm3.408,0a1.078,1.078,0,1,0-1.078,1.159,1.067,1.067,0,0,0,1.078-1.159Z",
    transform: "translate(-565.449 -239.206)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5910",
    "data-name": "Path 5910",
    d: "M636.834,313.521a1.681,1.681,0,0,1-1,.267,1.391,1.391,0,0,1-1.576-1.519v-1.739H633.6v-.939h.661V308.56h1.229v1.032h1.055v.939H635.49v1.727a.487.487,0,0,0,.522.556.823.823,0,0,0,.5-.162Z",
    transform: "translate(-564.768 -239.287)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5911",
    "data-name": "Path 5911",
    d: "M641.046,311.837h-3.2a1.159,1.159,0,0,0,1.159.846,1.426,1.426,0,0,0,1.066-.406l.649.707a2.168,2.168,0,0,1-1.739.684,2.191,2.191,0,0,1-2.423-2.179,2.156,2.156,0,0,1,2.26-2.179,2.1,2.1,0,0,1,2.2,2.2A.611.611,0,0,1,641.046,311.837Zm-3.223-.719h2.087a1,1,0,0,0-1.032-.881,1.009,1.009,0,0,0-1.055.881Z",
    transform: "translate(-564.296 -239.168)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18152",
    "data-name": "Rectangle 18152",
    width: 46.414,
    height: 30.904,
    transform: "translate(52.229 79.378) rotate(-80.05)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5912",
    "data-name": "Path 5912",
    d: "M657.742,283.189a3.383,3.383,0,0,1-.58-.07l-1.623-.255-6.155-1.02-22.129-3.779.278-.2c-2.191,12.6-4.961,28.5-7.952,45.73,0,.081-.464-.661-.243-.348h.5l.51.081,1.008.185,2.017.348,3.976.707,7.778,1.368,14.641,2.585-.313.22c2.4-13.389,4.44-24.772,5.889-32.84.742-4.011,1.322-7.2,1.727-9.424.209-1.078.371-1.913.475-2.515l.139-.661a1.375,1.375,0,0,1,0-.232,1.435,1.435,0,0,1,0,.209l-.093.626c-.093.6-.232,1.426-.406,2.481-.371,2.214-.893,5.39-1.565,9.378l-5.657,33.072v.278h-.278l-14.641-2.55-7.79-1.356-3.976-.707-2.017-.348-1.009-.174-.51-.093h-.5c.209.313-.3-.417-.255-.348,3.049-17.226,5.8-33.106,8.114-45.707v-.243h.232l22.233,4.034,6.074,1.159,1.577.3Z",
    transform: "translate(-567.094 -244.217)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5913",
    "data-name": "Path 5913",
    d: "M632.907,302.52l5.019,3.3-.22,1.24-5.8,1.391.243-1.356,4.161-.974-3.582-2.318Z",
    transform: "translate(-565.037 -240.249)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5914",
    "data-name": "Path 5914",
    d: "M635.892,303.885a2.318,2.318,0,1,1,2.55-1.913,2.179,2.179,0,0,1-2.55,1.913Zm.591-3.35a1.09,1.09,0,1,0,.945.674,1.09,1.09,0,0,0-.945-.674Z",
    transform: "translate(-564.73 -240.767)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5915",
    "data-name": "Path 5915",
    d: "M639.192,296.616a1.693,1.693,0,0,1,.093,1.032,1.4,1.4,0,0,1-1.774,1.3l-1.716-.3-.1.638-.927-.162.1-.638-1.008-.185.209-1.159,1.02.185.174-1.043.927.162-.174,1.043,1.692.29a.475.475,0,0,0,.638-.417.869.869,0,0,0-.058-.522Z",
    transform: "translate(-564.726 -241.242)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5916",
    "data-name": "Path 5916",
    d: "M638.231,292.385l-.556,3.153a1.159,1.159,0,0,0,1.043-1.043,1.4,1.4,0,0,0-.22-1.159l.811-.522a2.144,2.144,0,0,1,.371,1.831,2.191,2.191,0,0,1-2.562,2.005,2.144,2.144,0,0,1-1.75-2.6,2.087,2.087,0,0,1,2.539-1.8Zm-1.264,3.06.359-2.052a1.055,1.055,0,0,0-.359,2.052Z",
    transform: "translate(-564.495 -241.891)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5917",
    "data-name": "Path 5917",
    d: "M652.843,279.93c.093.139-10.015,7.4-22.593,16.229s-22.848,15.834-22.94,15.7,10.015-7.384,22.593-16.229S652.75,279.8,652.843,279.93Z",
    transform: "translate(-568.953 -243.845)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5918",
    "data-name": "Path 5918",
    d: "M653.41,274.62c.093.139-7.975,5.877-18.014,12.809s-18.257,12.45-18.4,12.311,7.975-5.865,18.014-12.809S653.306,274.493,653.41,274.62Z",
    transform: "translate(-567.41 -244.69)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18153",
    "data-name": "Rectangle 18153",
    width: 87.808,
    height: 10.259,
    transform: "translate(13.4)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18154",
    "data-name": "Rectangle 18154",
    width: 87.808,
    height: 4.161,
    transform: "translate(13.493 86.464)",
    fill: "#263238"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElections);
export default __webpack_public_path__ + "static/media/elections.92ebec3e89d0906e4a428b6f3d0d0e9b.svg";
export { ForwardRef as ReactComponent };